import i18n from "@/i18n";
import { storeS } from "@/store";

function mutateMonitoringType(e) {
  let name = "";
  let color = "";

  switch (e) {
    case "payments":
      name = i18n.global.t("Payment");
      color = "badge bg-secondary";
      break;
    case "problems":
      name = i18n.global.t("trouble_client");
      color = "badge bg-warning";
      break;
    case "desagree":
      name = i18n.global.t("desagree_from_program");
      color = "badge bg-danger";
      break;
    case "another":
      name = i18n.global.t("other");
      color = "badge bg-violet";
      break;
    default:
      name = "-";
      color = "";
  }

  return { name: name, color: color };
}

function mutateTriggers(e) {
  let name = "";
  switch (e) {
    case "35daysFromLastInventory":
      name = i18n.global.t("35daysFromLastInventory");
      break;
    case "14daysNoComing":
      name = i18n.global.t("14daysNoComing");
      break;
    case "21daysNoInventory":
      name = i18n.global.t("21daysNoInventory");
      break;
    case "7daysFromLastCollection":
      name = i18n.global.t("7daysFromLastCollection");
      break;
    case "21daysNoCollection":
      name = i18n.global.t("21daysNoCollection");
      break;
  }

  return name;
}

function mutateStatusMessage(e) {
  let name;
  let color;

  switch (e) {
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge bg-secondary";
      break;
    case "confirmed":
      name = i18n.global.t("Confirmed");
      color = "badge bg-success";
      break;
  }

  return { name: name, color: color };
}

function mutateTypeMessage(e) {
  let name = "";
  let color = "";

  switch (e) {
    case "alert":
      name = i18n.global.t("Alerts");
      color = "badge badge-soft-info";
      break;
    case "update":
      name = i18n.global.t("Updates");
      color = "badge badge-soft-success";
      break;

    default:
      name = i18n.global.t("Null");
      break;
  }

  return { color, name };
}

function mutateViewMessage(e) {
  let name = "";
  switch (e) {
    case "-3":
      name = i18n.global.t("onBothPlatforms");
      break;
    case "-1":
      name = i18n.global.t("onlyAdmin");
      break;
    case "-2":
      name = i18n.global.t("onlyTerminal");
      break;

    default:
      name = i18n.global.t("Null");
      break;
  }

  return name;
}

function mutateRecipientMessage(e) {
  let name = "";
  switch (e) {
    case "-1":
      name = i18n.global.t("allUsers");
      break;
    case "-2":
      name = i18n.global.t("admins");
      break;

    default:
      name = i18n.global.t("User");
      break;
  }

  return name;
}

function mutateAppName(e) {
  var name, color;
  switch (e) {
    case "shakeToPay":
      name = "shakeToPay";
      color = "badge bg-success fs-12";
      break;
    // case "expirenza":

    // break;
    // case value:

    // break;
    default:
      name = "-";
      color = "badge bg-primary fs-12";
      break;
  }
  return { color, name };
}

function mutatePaymentType(e, obj) {
  let value = e ? e : obj.type; // перебираємо, якщо існує тип
  var name, color;
  switch (value) {
    case "tariff_payment":
      name = i18n.global.t("tariff_payment");
      color = "badge bg-success fs-12";
      break;

    case "refill":
      name = i18n.global.t("ToppingUptheAccountBalance");
      color = "badge bg-info fs-12";
      break;

    case "apps_payment":
      name = i18n.global.t("apps_payment") + " (" + obj.appName + ")";
      color = "badge bg-warning fs-12";
      break;

    case "other":
      name = i18n.global.t("Other");
      color = "badge bg-info fs-12";
      break;

    case "forservice":
      name = i18n.global.t("forservice");
      color = "badge bg-success fs-12";
      break;

    case "punishment":
      name = i18n.global.t("Fine");
      color = "badge bg-danger fs-12";
      break;

    case "tariff_recalculation":
      name = i18n.global.t("Перерахунок тарифу");
      if (obj.days < 0) {
        color = "badge bg-danger fs-12";
      } else {
        color = "badge bg-success fs-12";
      }
      break;

    case "activate_credit_period":
      name = i18n.global.t("Активація кредитного ліміту");
      color = "badge bg-danger fs-12";
      break;

    default:
      name = "";
      color = "";
      break;
  }
  return { color, name };
}

function mutatePhone(e) {
  var numcode = [
    "075",
    "039",
    "067",
    "068",
    "096",
    "097",
    "098",
    "050",
    "066",
    "095",
    "099",
    "063",
    "073",
    "093",
    "091",
    "092",
    "089",
    "094",
  ];

  numcode.forEach((el) => {
    if (String(e).substr(0, 3) == el) {
      e = "38" + e;
      return e;
    }
  });

  return e;
}

function getMonth(e) {
  var res = "";
  if (String(e).indexOf("0") === 0) {
    e = String(e).replace("0", "");
  } else {
    e = String(e);
  }
  switch (e) {
    case "1":
      res = "January";
      break;
    case "2":
      res = "February";
      break;
    case "3":
      res = "March";
      break;
    case "4":
      res = "April";
      break;
    case "5":
      res = "May";
      break;
    case "6":
      res = "June";
      break;
    case "7":
      res = "July";
      break;
    case "8":
      res = "August";
      break;
    case "9":
      res = "September";
      break;
    case "10":
      res = "October";
      break;
    case "11":
      res = "November";
      break;
    case "12":
      res = "December";
      break;
  }
  return res;
}

function mutateNoticeAlerts(e) {
  var color = "";
  var icon = "";
  var text = "";
  switch (e.noticeTitle) {
    case "restoreMonitoring":
      color = "success";
      text = i18n.global.t("resumeMonitoring");
      icon = "bx bx-scan";
      break;
    case "stopMonitoring":
      color = "danger";
      text = i18n.global.t("stopMonitoring");
      icon = "bx bx-scan";
      break;
    case "saveAssignedWorkers":
      color = "warning";
      text = i18n.global.t("saveAssignedWorkers");
      icon = "bx bx-scan";
      break;
    case "exitAssignedWorkers":
      color = "danger";
      text = i18n.global.t("exitAssignedWorkers");
      icon = "bx bx-scan";
      break;
    case "exitAssignedPresentation":
      color = "danger";
      text = i18n.global.t("exitAssignedPresentation");
      icon = "bx bxs-left-arrow-alt";
      break;
    case "addToMonitoring":
      color = "success";
      text = i18n.global.t("addToMonitoring");
      icon = "bx bx-transfer";
      break;
    case "transferColdCall":
      color = "info";
      text = i18n.global.t("transferColdCall");
      icon = "bx bx-transfer";
      break;
    case "exitAssignedTicket":
      color = "info";
      text = i18n.global.t("statusLeaveticket");
      icon = "ri-ticket-2-line";
      break;
    case "replyOnMessageInTicketChat":
      color = "info";
      text = i18n.global.t("YouWereAnsweredTicket");
      icon = "bx bx-message-error";
      break;
    case "addHoliday":
      color = "info";
      text = i18n.global.t("createdHolidayuserAlert");
      icon = "bx bx-party";
      break;
    case "closedTicket":
      color = "success";
      text = i18n.global.t("yourTicketClose");
      icon = "ri-ticket-2-line";
      break;
    case "reopenedTicket":
      color = "warning";
      text = i18n.global.t("reopenTicket");
      icon = "ri-ticket-2-line";
      break;
    case "saveAssignedWorkers":
      color = "secondary";
      text = i18n.global.t("ticketBeenAssignedYou");
      icon = "ri-ticket-2-line";
      break;
    case "confirmTask":
      color = "success";
      text = i18n.global.t("confirmTaskNotice");
      icon = "ri-task-line";
      break;
    case "transferTask":
      color = "warning";
      text = i18n.global.t("transferManagerTask");
      icon = "bx bx-transfer";
      break;
    case "addTaskWaitConfirm":
      color = "success";
      text = i18n.global.t("AddedNewTask");
      icon = "ri-task-line";
      break;
    case "cancelTask":
      color = "danger";
      text = i18n.global.t("TaskCanceled");
      icon = "ri-task-line";
      break;
    case "transferPresentation":
      color = "warning";
      text = i18n.global.t("transferManagerPresent");
      icon = "bx bx-transfer";
      break;
    case "addNewPresentation":
      color = "success";
      text = i18n.global.t("PresentationRequestCreated");
      icon = "bx bxl-skype";
      break;
    case "cancelPresentation":
      color = "danger";
      text = i18n.global.t("PresentationCanceled");
      icon = "bx bxl-skype";
      break;
    case "transferDump":
      color = "warning";
      text = i18n.global.t("transferManagerDump");
      icon = "bx bx-transfer";
      break;
    case "addDump":
      color = "info";
      text = i18n.global.t("dumpRequestCreated");
      icon = "bx bxs-phone-call";
      break;
    case "transferRequest":
      color = "warning";
      text = i18n.global.t("transferManagerRequest");
      icon = "bx bx-transfer";
      break;
    case "waitReleaseTicket":
      color = "info";
      text = i18n.global.t("waitReleaseTicket");
      icon = "ri-task-line";
      break;
    case "decidedTicket":
      color = "info";
      text = i18n.global.t("SolutionAddedYourTicket");
      icon = "ri-task-line";
      break;
    case "addNewRequest":
      switch (e.noticeData.call) {
        case "missing":
          color = "danger";
          text = i18n.global.t("missingCall");
          icon = "bx bxs-phone-off";
          break;
        default:
          color = "success";
          text = i18n.global.t("newApplication");
          icon = "bx bxs-phone-call";
          break;
      }
      break;
    case "cancelRequest":
      color = "danger";
      text = i18n.global.t("canceled");
      icon = "bx bxs-phone-off";
      break;
    case "sendMessageInTicketChat":
      color = "info";
      text = i18n.global.t("sendMessageInTicketChat");
      icon = "bx bx-message-square-add";
      break;
    case "inJobTicketManually":
      color = "info";
      text = i18n.global.t("ticketBeenAssignedYou");
      icon = "ri-task-line";
      break;
    case "getRequest":
      switch (e.noticeData.call) {
        case "missing":
          color = "danger";
          text = i18n.global.t("missingCall");
          icon = "bx bxs-phone-off";
          break;
      }
      break;
    case "createdTicket":
      color = "info";
      text = i18n.global.t("NewTicketAdded");
      icon = "ri-add-line";
      break;
    case "inJobTicket":
      color = "secondary";
      text = i18n.global.t("ticketInJobAlert");
      icon = "bx bxs-pie-chart";
      break;
    case "closeBreak":
      color = "secondary";
      text =
        e.noticeData.workerName +
        " " +
        i18n.global.t("closedBreak") +
        ". " +
        i18n.global.t("Duration") +
        " " +
        Math.trunc(e.noticeData.duration / 60) +
        " " +
        i18n.global.t("min") +
        " " +
        (e.noticeData.duration - 60 * Math.trunc(e.noticeData.duration / 60) !=
        0
          ? e.noticeData.duration - 60 * Math.trunc(e.noticeData.duration / 60)
          : "") +
        " " +
        i18n.global.t("sec");
      icon = "ri-timer-line";
      break;
    case "createBreak":
      color = "secondary";
      text =
        e.noticeData.workerName +
        " " +
        (String(i18n.global.t("GoneforBreak")).split("")[0].toLowerCase() +
          String(i18n.global.t("GoneforBreak")).slice(
            1,
            i18n.global.t("GoneforBreak").length
          ));
      icon = "ri-timer-line";
      break;
    case "exitTicket":
      color = "secondary";
      text = i18n.global.t("ticketInJobAlert");
      icon = "bx bxs-pie-chart";
      break;
    case "stopTicket":
      color = "danger";
      text = i18n.global.t("stopTicketStatus");
      icon = "bx bxs-pie-chart";
      break;
    case "resumeTicket":
      color = "success";
      text = i18n.global.t("resumeTicketStatus");
      icon = "bx bxs-pie-chart";
      break;
    case "addReportOnCancelRequest":
      color = "warning";
      text = i18n.global.t("addReportOnCancelRequest");
      icon = "bx bxs-report";
      break;
  }
  return { color, icon, text };
}

function mutateTypeRequest(e) {
  var name = "";
  var color = "";
  var icon = "";
  switch (e) {
    case "outgoing":
      name = i18n.global.t("outgoing");
      icon = "bx bx-phone-outgoing";
      color = "badge bg-secondary";
      break;
    case "incoming":
      name = i18n.global.t("incoming");
      icon = "bx bx-phone-incoming";
      color = "badge bg-success";
      break;
    case "missing":
      name = i18n.global.t("missing");
      icon = "bx bxs-phone-off";
      color = "badge bg-danger";
      break;
    default:
      name = "-";
      color = "badge bg-black";
      break;
  }
  return { name, color, icon };
}

function mutatePriority(e) {
  // пріоритет
  var name = "";
  var color = "";
  var bgcolor = "";
  var bg = "";
  switch (e) {
    case 2:
      name = i18n.global.t("priorityHigh");
      color = "badge badge-soft-danger";
      bg = "badge bg-danger";
      break;
    case 1:
      name = i18n.global.t("priorityMedium");
      color = "badge badge-soft-warning";
      bg = "badge bg-warning";
      break;
    case 0:
      name = i18n.global.t("priorityLow");
      color = "badge badge-soft-info";
      bg = "badge bg-info";
      break;
  }
  return { name, color, bg };
}

// holiday, вихідний, відпустка

function mutateTypeHoliday(e) {
  //тип вихідного
  var name = "";
  switch (e) {
    case "graphs":
      name = i18n.global.t("Vacation");
      break;
    case "vacation":
      name = i18n.global.t("Vacation");
      break;
    case "dayoff":
      name = i18n.global.t("DayOff");
      break;
    default:
      break;
  }
  return name;
}

function mutateReasonHoliday(e) {
  //причина вихідного
  var name = "";
  switch (e) {
    case "0":
      name = i18n.global.t("fellIll");
      break;
    case "1":
      name = i18n.global.t("IllnessFamilyMember");
      break;
    case "2":
      name = i18n.global.t("BodyCheck");
      break;
    case "3":
      name = i18n.global.t("ownReason");
      break;
    default:
      name = storeS.checks["024"] == true ? "Party" : "-";
      break;
  }
  return name;
}

function mutateStatusHoliday(e) {
  // статус заявки на вихідний/відпустки
  var name = "";
  var color = "";
  switch (e) {
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge bg-info";
      break;
    case "canceled":
      name = i18n.global.t("Refusal");
      color = "badge bg-danger";
      break;
    case "confirmed":
      name = i18n.global.t("Confirmed");
      color = "badge bg-success";
      break;
    default:
      break;
  }
  return { name, color };
}

// holiday, вихідний, відпустка

// відвали
function mutateStatusDumpArchive(e, obj) {
  var r = "";
  var cl = "";
  switch (e) {
    case "closed":
      r = i18n.global.t("closed");
      cl = "badge badge-soft-danger";
      break;
    case "canceled":
      r = i18n.global.t("canceled");
      cl = "badge badge-soft-danger";
      break;
    case "delayed":
      r = i18n.global.t("PostponedUntil") + " " + obj.delayedDatetime;
      cl = "badge badge-soft-warning";
      break;
    case "new":
      r = i18n.global.t("statusNew");
      cl = "badge badge-soft-info";
      break;
    case "jobs":
      // r = i18n.global.t('statusInWork') + " " + obj.inJobWorkerName
      r = i18n.global.t("wait_comment") + " " + obj.inJobWorkerName;
      cl = "badge badge-soft-secondary";
      break;
    case "rescheduled":
      r = i18n.global.t("statusrescheduled");
      cl = "badge badge-soft-secondary";
      break;
    case "Executed":
      r = i18n.global.t("Executed");
      cl = "badge badge-soft-secondary";
      break;
    case "deleted":
      r = i18n.global.t("Removed");
      cl = "badge badge-soft-danger";
      break;
    case "wait_remove":
      r = i18n.global.t("statuswait_delete");
      cl = "badge badge-soft-danger";
      break;
  }
  return { r, cl };
}
// відвали

// tickets, тикети

function mutateTicket(e) {
  //тип тикета
  var name = "";
  switch (e) {
    case "problem":
      name = i18n.global.t("problem_to_develop");
      break;
    case "wishes":
      name = i18n.global.t("wish_to_develop");
      break;
  }
  return name;
}

function mutateWayproblem(e) {
  //середовище проблеми
  var name = "";
  switch (e) {
    case "device_printer":
      name = i18n.global.t("device_printer");
      break;
    case "-":
      name = "-";
      break;
  }
  return name;
}

function mutateReleasesCalendar(e) {
  /*
        { value: 'all', label: i18n.global.t('all') },
        { value: 'skyservice', label: 'SkyService' },
        { value: 'posterminal', label: 'Pos-terminal' },
        { value: 'dashboard', label: 'Dashboard' },
        { value: 'skymarket', label: 'Sky Market' },
        { value: 'sellup', label: 'SellUP' },
        { value: 'hallscreen', label: i18n.global.t('orderBoard') },
        { value: 'inside', label: 'Inside' },
        { value: 'android', label: i18n.global.t('onlyForAndroid') },
        { value: 'ios', label: i18n.global.t('onlyForIOS') },
    */

  var name = "";
  var color = "";

  switch (e) {
    case "all":
      name = "";
      color = "bg-soft-dark";
      break;
    case "skyservice":
      name = "";
      color = "bg-soft-primary";
      break;
    case "posterminal":
      name = "";
      color = "bg-soft-secondary";
      break;
    case "dashboard":
      name = "";
      color = "bg-soft-success";
      break;
    case "skymarket":
      name = "";
      color = "bg-soft-secondary";
      break;
    case "sellup":
      name = "";
      color = "bg-soft-danger";
      break;
    case "hallscreen":
      name = "";
      color = "bg-soft-warning";
      break;
    case "inside":
      name = "";
      color = "bg-soft-info";
      break;
    case "android":
      name = "";
      color = "bg-soft-success";
      break;
    case "ios":
      name = "";
      color = "bg-soft-dark";
      break;
  }
  return { color: color, name: name };
}

function mutateStatusUpdates(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "pre_release":
      name = i18n.global.t("pre_release");
      color = "badge bg-warning";
      break;
    case "in_release":
      name = i18n.global.t("inRelease");
      color = "badge bg-success";
      break;
    case "new":
      name = i18n.global.t("new");
      color = "badge bg-info";
      break;
    default:
      name = "-";
      color = "white";
      break;
  }
  return { name, color };
}

function mutateStatusTicket(e) {
  //статус
  var name = "";
  var color = "";
  switch (e) {
    case "stop":
      name = i18n.global.t("stopTicketStatus");
      color = "badge badge-soft-danger";
      break;
    case "viewed":
      name = i18n.global.t("statusViewed");
      color = "badge badge-soft-secondary";
      break;
    case "wait_jobs":
      name = i18n.global.t("statusWaitJob");
      color = "badge badge-soft-secondary";
      break;
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge badge-soft-info";
      break;
    case "jobs":
      name = i18n.global.t("statusInWork");
      color = "badge badge-soft-secondary";
      break;
    case "statusCompleted":
      name = i18n.global.t("statusCompleted");
      color = "badge badge-soft-success";
      break;
    case "waittesting":
      name = i18n.global.t("waitTesting");
      color = "badge badge-soft-warning";
      break;
    case "intesting":
      name = i18n.global.t("inTesting");
      color = "badge badge-soft-info";
      break;
    case "waitrelease":
      name = i18n.global.t("waitRelease");
      color = "badge badge-soft-success";
      break;
    case "in_release":
      name = i18n.global.t("inRelease");
      color = "badge badge-soft-success";
      break;
    case "decided":
      name = i18n.global.t("statusCompleted");
      color = "badge badge-soft-success";
      break;
    case "closed":
      name = i18n.global.t("ticketClose");
      color = "badge badge-soft-secondary";
      break;
    case "deleted":
      name = i18n.global.t("Removed");
      color = "badge badge-soft-danger";
      break;
    case "restored":
      name = i18n.global.t("Restored");
      color = "badge badge-soft-secondary";
      break;
  }
  return { name, color };
}

function mutatePriorityTicket(e) {
  // пріоритет
  var name = "";
  var color = "";
  var oc = "";
  var bgcolor = "";
  var colorProj = "";
  switch (e) {
    case 3:
      name = i18n.global.t("Critical");
      color = "badge bg-danger";
      oc = "badge bg-soft-danger";
      bgcolor = "bg-danger";
      colorProj = "badge-soft-danger";
      break;
    case 2:
      name = i18n.global.t("priorityHigh");
      color = "badge bg-danger";
      oc = "badge bg-soft-danger";
      bgcolor = "bg-danger";
      colorProj = "badge-soft-danger";
      break;
    case 1:
      name = i18n.global.t("priorityMedium");
      color = "badge bg-warning";
      oc = "badge bg-soft-warning";
      bgcolor = "bg-warning";
      colorProj = "badge-soft-warning";
      break;
    case 0:
      name = i18n.global.t("priorityLow");
      color = "badge bg-success";
      oc = "badge bg-soft-info";
      bgcolor = "bg-soft-info";
      colorProj = "badge-soft-info";
      break;
  }
  return { name, color, oc, bgcolor, colorProj };
}

function mutateDecidedStatusTicket(e) {
  // рішення
  var name = "";
  var color = "";
  switch (e) {
    case "pre_release":
      name = i18n.global.t("pre_release");
      color = "badge bg-warning";
      break;
    case "waittesting":
      name = i18n.global.t("waitTesting");
      color = "badge bg-warning";
      break;
    case "intesting":
      name = i18n.global.t("inTesting");
      color = "badge bg-info";
      break;
    case "waitrelease":
      name = i18n.global.t("waitRelease");
      color = "badge bg-secondary";
      break;
    case "statusCompleted":
      name = i18n.global.t("statusCompleted");
      color = "badge bg-success";
      break;
    case "in_release":
      name = i18n.global.t("inRelease");
      color = "badge bg-success";
      break;
    case "noProblem":
      name = i18n.global.t("noProblem");
      color = "badge bg-secondary";
      break;
    case "fixedForClient":
      name = i18n.global.t("fixedForClient");
      color = "badge bg-success";
      break;
    case "reconsideration":
      name = i18n.global.t("Reconsideration");
      color = "badge bg-danger";
      break;
    default:
      name = "-";
      break;
  }
  return { name, color };
}

function mutateProblemEnv(e) {
  var name = "";
  switch (e) {
    case "QMenu":
      name = i18n.global.t("App") + " " + i18n.global.t("QMenu");
      break;
    case "Screen_for_the_kitchen":
      name = i18n.global.t("Screen_for_the_kitchen");
      break;
    case "hallScreen":
      name = i18n.global.t("hallScreen");
      break;
    case "tPay":
      name = i18n.global.t("App") + " tPay";
      break;
    case "admin_sendcheck":
      name = i18n.global.t("admin_sendcheck");
      break;
    case "admin_marketingDiscount":
      name = i18n.global.t("admin_marketingDiscount");
      break;
    case "inside":
      name = "Inside";
      break;
    case "App":
      name = i18n.global.t("App");
      break;
    case "newDashboard":
      name = i18n.global.t("NewAdmin_panel");
      break;
    case "admin_allappsSkymarket":
      name = i18n.global.t("admin_allappsSkymarket");
      break;
    case "admin_allappsSellup":
      name = i18n.global.t("admin_allappsSellup");
      break;
    case "admin_allappsHscreen":
      name = i18n.global.t("admin_allappsHscreen");
      break;
    case "admin_allappsMono":
      name = i18n.global.t("admin_allappsMono");
      break;
    case "admin_shake_to_pay":
      name = i18n.global.t("admin_shake_to_pay");
      break;
    case "admin_allappsBookBeauty":
      name = i18n.global.t("admin_allappsBookBeauty");
      break;
    case "admin_allappsPrivat":
      name = i18n.global.t("admin_allappsPrivat");
      break;
    case "admin_panel":
      name = i18n.global.t("admin_panel");
      break;
    case "pos_terminal":
      name = i18n.global.t("dir_pos");
      break;
    case "posnew":
      name = i18n.global.t("dir_posnew");
      break;
    case "admin_allProducts":
      name = i18n.global.t("admin_allProducts");
      break;
    case "admin_warehouseProducts":
      name = i18n.global.t("admin_warehouseProducts");
      break;
    case "admin_services":
      name = i18n.global.t("admin_services");
      break;
    case "admin_Onsale":
      name = i18n.global.t("admin_Onsale");
      break;
    case "admin_remains":
      name = i18n.global.t("admin_remains");
      break;
    case "admin_reportsMain":
      name = i18n.global.t("admin_reportsMain");
      break;
    case "admin_reportsSale":
      name = i18n.global.t("admin_reportsSale");
      break;
    case "admin_reportsComings":
      name = i18n.global.t("admin_reportsComings");
      break;
    case "admin_reportsReturns":
      name = i18n.global.t("admin_reportsReturns");
      break;
    case "admin_reportsMove":
      name = i18n.global.t("admin_reportsMove");
      break;
    case "admin_reportsManufacture":
      name = i18n.global.t("admin_reportsManufacture");
      break;
    case "admin_reportsOpenshifts":
      name = i18n.global.t("admin_reportsOpenshifts");
      break;
    case "admin_reportsBonusreports":
      name = i18n.global.t("admin_reportsBonusreports");
      break;
    case "admin_reportsGoodsconsumption":
      name = i18n.global.t("admin_reportsGoodsconsumption");
      break;
    case "admin_reportsTopsales":
      name = i18n.global.t("admin_reportsTopsales");
      break;
    case "admin_reportsABCproducts":
      name = i18n.global.t("admin_reportsABCproducts");
      break;
    case "admin_reportsABCcategories":
      name = i18n.global.t("admin_reportsABCcategories");
      break;
    case "admin_reportsTopcomings":
      name = i18n.global.t("admin_reportsTopcomings");
      break;
    case "admin_reportsTopclients":
      name = i18n.global.t("admin_reportsTopclients");
      break;
    case "admin_reportsDays":
      name = i18n.global.t("admin_reportsDays");
      break;
    case "admin_reportsDecommissionedgoods":
      name = i18n.global.t("admin_reportsDecommissionedgoods");
      break;
    case "admin_reportsGoods":
      name = i18n.global.t("admin_reportsGoods");
      break;
    case "admin_reportsTopsales":
      name = i18n.global.t("admin_reportsTopsales");
      break;
    case "admin_reportsABCproducts":
      name = i18n.global.t("admin_reportsABCproducts");
      break;
    case "admin_reportsABCcategories":
      name = i18n.global.t("admin_reportsABCcategories");
      break;
    case "admin_reportsTopcomings":
      name = i18n.global.t("admin_reportsTopcomings");
      break;
    case "admin_reportsTopclients":
      name = i18n.global.t("admin_reportsTopclients");
      break;
    case "admin_reportsDays":
      name = i18n.global.t("admin_reportsDays");
      break;
    case "admin_reportsDecommissionedgoods":
      name = i18n.global.t("admin_reportsDecommissionedgoods");
      break;
    case "admin_reportsGoods":
      name = i18n.global.t("admin_reportsGoods");
      break;
    case "admin_reportsGoodscategory":
      name = i18n.global.t("admin_reportsGoodscategory");
      break;
    case "admin_reportsSalesdynamic":
      name = i18n.global.t("admin_reportsSalesdynamic");
      break;
    case "admin_reportsRevenuereport":
      name = i18n.global.t("admin_reportsRevenuereport");
      break;
    case "admin_reportsWorkshop":
      name = i18n.global.t("admin_reportsWorkshop");
      break;
    case "admin_reportsEmployee":
      name = i18n.global.t("admin_reportsEmployee");
      break;
    case "admin_reportsInventory":
      name = i18n.global.t("admin_reportsInventory");
      break;
    case "admin_reportsDanger":
      name = i18n.global.t("admin_reportsDanger");
      break;
    case "admin_reportsRecommendpurchase":
      name = i18n.global.t("admin_reportsRecommendpurchase");
      break;
    case "admin_reportsTaxes":
      name = i18n.global.t("admin_reportsTaxes");
      break;
    case "admin_reportsShifts":
      name = i18n.global.t("admin_reportsShifts");
      break;
    case "admin_reportsWalletsstatus":
      name = i18n.global.t("admin_reportsWalletsstatus");
      break;
    case "admin_reportsFin":
      name = i18n.global.t("admin_reportsFin");
      break;
    case "admin_reportsCashboxallmotions":
      name = i18n.global.t("admin_reportsCashboxallmotions");
      break;
    case "admin_reportsCashboxinkmotions":
      name = i18n.global.t("admin_reportsCashboxinkmotions");
      break;
    case "admin_reportsCashboxoutmotions":
      name = i18n.global.t("admin_reportsCashboxoutmotions");
      break;
    case "admin_reportsCashboxsalemotions":
      name = i18n.global.t("admin_reportsCashboxsalemotions");
      break;
    case "admin_reportsCashboxinmotions":
      name = i18n.global.t("admin_reportsCashboxinmotions");
      break;
    case "admin_reportsWalletallmotions":
      name = i18n.global.t("admin_reportsWalletallmotions");
      break;
    case "admin_reportsWalletoutmotions":
      name = i18n.global.t("admin_reportsWalletoutmotions");
      break;
    case "admin_marketingClients":
      name = i18n.global.t("admin_marketingClients");
      break;
    case "admin_marketingOffers":
      name = i18n.global.t("admin_marketingOffers");
      break;
    case "admin_marketingStock":
      name = i18n.global.t("admin_marketingStock");
      break;
    case "admin_marketingBonus":
      name = i18n.global.t("admin_marketingBonus");
      break;
    case "admin_settingsglobal":
      name = i18n.global.t("admin_settingsglobal");
      break;
    case "admin_settingstradepoints":
      name = i18n.global.t("admin_settingstradepoints");
      break;
    case "admin_settingscategory":
      name = i18n.global.t("admin_settingscategory");
      break;
    case "admin_settingsexpenses":
      name = i18n.global.t("admin_settingsexpenses");
      break;
    case "admin_settingstax":
      name = i18n.global.t("admin_settingstax");
      break;
    case "admin_settingsworkshop":
      name = i18n.global.t("admin_settingsworkshop");
      break;
    case "admin_settingsnotices":
      name = i18n.global.t("admin_settingsnotices");
      break;
    case "admin_settingshalls":
      name = i18n.global.t("admin_settingshalls");
      break;
    case "admin_settingstables":
      name = i18n.global.t("admin_settingstables");
      break;
    case "admin_settingsdevices":
      name = i18n.global.t("admin_settingsdevices");
      break;
    case "admin_settingsusers":
      name = i18n.global.t("admin_settingsusers");
      break;
    case "admin_settingsprovider":
      name = i18n.global.t("admin_settingsprovider");
      break;
    case "admin_settingswallets":
      name = i18n.global.t("admin_settingswallets");
      break;
    case "admin_settingsmybalance":
      name = i18n.global.t("admin_settingsmybalance");
      break;
    case "admin_settingspartnersprogram":
      name = i18n.global.t("admin_settingspartnersprogram");
      break;
    case "admin_help":
      name = i18n.global.t("admin_help");
      break;
  }
  return name;
}

// tickets, тикети

// breaks, перерва

function mutateBreak(e) {
  // причина перерви
  var name = "";
  switch (e) {
    case "lunch":
      name = i18n.global.t("Dinner");
      break;
    case "smokebreak":
      name = i18n.global.t("smokeBreak");
      break;
    case "dinner":
      name = i18n.global.t("Dinner");
      break;
    case "closeSIP":
      name = i18n.global.t("closeSIP");
    default:
      break;
  }
  return name;
}

// breaks, перерва

// event, calendar, календар

function mutateTypeCalendar(e, obj) {
  //тип івенту
  var name = "";
  var color = "";
  var bgcolor = "";
  switch (e) {
    case "presentation":
      name = i18n.global.t("presentation");
      color = "bg-soft-info";
      bgcolor = "bg-info";
      break;
    case "connection":
      name = i18n.global.t("connectionDevice");
      color = "bg-soft-info";
      bgcolor = "bg-info";
      break;
    case "task":
      name = i18n.global.t("fiscal_Taskegistrar");
      color = "bg-soft-danger";
      bgcolor = "bg-danger";
      break;
    case "meeting":
      name = i18n.global.t("Meeting");
      color = "bg-soft-success";
      bgcolor = "bg-success";
      break;
    case "meetingPM":
      name = i18n.global.t("Meeting");
      color = "bg-soft-success";
      bgcolor = "bg-success";
      break;
    case "deadline":
      name = i18n.global.t("deadLine");
      color = "bg-soft-danger";
      bgcolor = "bg-danger";
      break;
    case "bday":
      name = i18n.global.t("bDay");
      color = "bg-soft-success";
      bgcolor = "bg-success";
      break;
    case "graphs":
      name = i18n.global.t("DayOff");
      if (obj?.holidayStatus === "new") {
        bgcolor = "bg-warning";
        color = "bg-soft-warning";
      } else {
        bgcolor = "bg-success";
        color = "bg-soft-success";
      }
      break;
    case "dayoff":
      name = i18n.global.t("DayOff");
      if (obj?.holidayStatus === "new") {
        bgcolor = "bg-warning";
        color = "bg-soft-warning";
      } else {
        bgcolor = "bg-success";
        color = "bg-soft-success";
      }
      break;
    case "vacation":
      name = i18n.global.t("Vacation");
      if (obj?.holidayStatus === "new") {
        bgcolor = "bg-warning";
        color = "bg-soft-warning";
      } else {
        bgcolor = "bg-success";
        color = "bg-soft-success";
      }
      break;
    case "clinic":
      name = i18n.global.t("clinicsOffs");
      bgcolor = "bg-success";
      color = "bg-soft-success";
      break;
    case "private":
      name = i18n.global.t("private");
      color = "bg-soft-secondary";
      bgcolor = "bg-secondary";
      break;
    case "other":
      name = i18n.global.t("Other");
      color = "bg-soft-secondary";
      bgcolor = "bg-secondary";
      break;

    default:
      break;
  }
  return { name, color, bgcolor };
}

function mutateStatusCalendar(e) {
  var name = "";
  switch (e) {
    case "private":
      name = i18n.global.t("private");
      break;
    case "public":
      name = i18n.global.t("ForAll");
      break;
  }
  return name;
}

// event, calendar, календар

// img, зображення

function mutateImgFiles(e) {
  var img = "";
  var color = "";
  switch (e) {
    case "image/jpeg":
      img = "ri-image-fill";
      color = "danger";
      break;
    case "image/png":
      img = "bx bxs-file-png";
      color = "danger";
      break;
    case "image/jpg":
      img = "ri-image-fill";
      color = "danger";
      break;
    case "file":
      img = "ri-file-fill";
      color = "secondary";
      break;
    case "application/json":
      img = "bx bxs-file-json";
      color = "info";
      break;
    case "application/txt":
      img = "bx bxs-file-txt";
      color = "info";
      break;
    case "application/doc":
      img = "bx bxs-file-doc";
      color = "info";
      break;
    case "application/docxdocx":
      img = "bx bxs-file-doc";
      color = "info";
      break;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      img = "ri-file-excel-fill";
      color = "success";
      break;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      img = "ri-file-excel-fill";
      color = "success";
      break;
    case "application/zip":
      img = "ri-file-zip-fill";
      color = "secondary";
      break;
    case "application/x-rar":
      img = "ri-inbox-archive-line";
      color = "secondary";
      break;
    case "video/quicktime":
      img = "ri-video-line";
      color = "secondary";
      break;
    case "video/mp4":
      img = "ri-video-fill";
      color = "info";
      break;
    case "application/pdf":
      img = "bx bxs-file-pdf";
      color = "danger";
      break;
    case "application/apk":
      img = "ri-android-fill";
      color = "success";
      break;
    case "application/octet-stream":
      img = "ri-terminal-line";
      color = "info";
      break;
    default:
      img = "ri-file-fill";
      color = "primary";
      break;
  }
  return { img, color };
}

function mutateImgWorker(e) {
  var img = "";
  var color = "";
  switch (e) {
    case "Win32":
      img = "ri-windows-fill";
      color = "info";
      break;
    case "MacIntel":
      img = "ri-apple-fill";
      color = "primary";
      break;
    case "Mac":
      img = "ri-mac-line";
      color = "primary";
      break;
    default:
      img = "ri-dashboard-fill";
      color = "secondary";
      break;
  }
  return { img, color };
}

// img, зображення

// workers, співробітники

function mutateWorkerJob(e) {
  // посада співробітника
  var name = "";
  switch (e) {
    case "HR":
      name = "HR";
      break;
    case "PM":
      name = i18n.global.t("PM");
      break;
    case "managercallcenter":
      name = i18n.global.t("managerCallCenter");
      break;
    case "salesmanager":
      name = i18n.global.t("SalesManager");
      break;
    case "supportmanager":
      name = i18n.global.t("SupportManager");
      break;
    case "developer":
      name = i18n.global.t("Developer");
      break;
    case "ceo":
      name = i18n.global.t("CEO");
      break;
    case "tester":
      name = i18n.global.t("Tester");
      break;
    case "smm":
      name = i18n.global.t("SMM");
      break;
    case "marketer":
      name = i18n.global.t("Marketer");
      break;
    case "owner":
      name = i18n.global.t("owner");
      break;
    default:
      name = "-";
      break;
  }
  return name;
}

// workers, співробітники

// shop

function titleCategory(item) {
  var name = "";
  storeS.productCategories.forEach((el) => {
    if (el.categoryId === item) {
      name = el.categoryName;
    }
  });
  return name;
}

// shop

// devices, пристрої

function mutateTemplateTicketPrinter(e) {
  var name = "";
  switch (e) {
    case "simple":
      name = i18n.global.t("temp_normal");
      break;
    case "advanced":
      name = i18n.global.t("temp_extended");
      break;
    case "jewelry":
      name = i18n.global.t("temp_jewelry");
      break;
    case "jewelry_mini":
      name = i18n.global.t("temp_jewelrymini");
      break;
    default:
      break;
  }
  return name;
}

function mutateModePrinter(e) {
  var name = "";
  switch (e) {
    case "text":
      name = i18n.global.t("mode_text");
      break;
    case "image":
      name = i18n.global.t("mode_graphic");
      break;
    default:
      break;
  }
  return name;
}

function mutateDirectionPrint(e) {
  var name = "";
  switch (e) {
    case "up":
      name = i18n.global.t("WayUp");
      break;
    case "down":
      name = i18n.global.t("Waydown");
      break;
    default:
      break;
  }
  return name;
}

function mutateTypeDevices(e) {
  var name = "";
  switch (e) {
    case "libra":
      name = i18n.global.t("device_scales");
      break;
    case "printer":
      name = i18n.global.t("device_printer");
      break;
    case "label_printer":
      name = i18n.global.t("device_label_printer");
      break;
    case "possystem":
      name = i18n.global.t("device_pos_terminal");
      break;
    case "rro":
      name = i18n.global.t("fiscal_registrar");
      break;
    case "banking":
      name = i18n.global.t("device_terminal");
      break;
    case "scanner":
      name = i18n.global.t("device_scanner");
      break;
    case "pool":
      name = i18n.global.t("device_table_control");
      break;
    case "screens":
      name = i18n.global.t("screens");
      break;
    default:
      break;
  }
  return name;
}

function mutateOS(e) {
  var name = "";
  switch (e) {
    case "windows":
      name = "Windows";
      break;
    case "android":
      name = "Android";
      break;
    case "ios":
      name = "IOS";
      break;
    case "macos":
      name = "Mac OS";
      break;
    case "all":
      name = i18n.global.t("all");
      break;
    case "other":
      name = i18n.global.t("all");
      break;
    default:
      break;
  }
  return name;
}

function mutateProtocol(e) {
  var name = "";
  switch (e) {
    case "electron_escpos_ethernet":
      name = i18n.global.t("electron_escpos_ethernet");
      break;
    case "electron_windowssystem_printer":
      name = i18n.global.t("electron_windowssystem_printer");
      break;
    case "electron_escpos_bluetooth":
      name = i18n.global.t("electron_escpos_bluetooth");
      break;
    case "electron_escpos_usb":
      name = i18n.global.t("electron_escpos_usb");
      break;
    case "printserver_windows_1808":
      name = i18n.global.t("printserver_windows_1808");
      break;
    case "epson_sdk_android_bluetooth_new":
      name = "Bluetooth";
      break;
    case "epson_sdk_android_usb_new":
      name = "USB";
      break;
    case "epson_sdk_android_ethernet_new":
      name = i18n.global.t("electron_escpos_ethernet");
      break;
    case "universal_sdk_ios_ethernet":
      name = i18n.global.t("electron_escpos_ethernet");
      break;
    case "epson_sdk_ios_bluetooth":
      name = "Bluetooth";
      break;
    case "system_printer_label_windows":
      name = i18n.global.t("system_printer_label_windows");
      break;
    case "usb_printer_label_windows":
      name = i18n.global.t("electron_escpos_usb");
      break;
    case "usb_label_android":
      name = "USB";
      break;
    case "d2mini":
      name = "Sunmi SDK";
      break;
    case "escpos_ingeniko_smart":
      name = "SDK Driver";
      break;
    case "verifone_x990":
      name = "APK Driver";
      break;
    case "smart_pos":
      name = "APK Driver";
      break;
    case "possectorSmartCubeDisplay":
      name = "SmartCube APK";
      break;
    case "androidcenterm":
      name = "Centerm SDK";
      break;
    case "android_pos_posin_new":
      name = "Posin SDK";
      break;
    case "androidsunmi":
      name = "Sunmi SDK";
      break;
    case "helpmicro":
      name = "HTTP";
      break;
    case "helpmicro2":
      name = "HTTP 2";
      break;
    case "minifp_usb_android_v2":
      name = "USB";
      break;
    case "minifp_ip_android_v2":
      name = "Ethernet/WiFi";
      break;
    case "artsoft_box":
      name = "artsoft.ua";
      break;
    case "uaprro":
      name = "ПРРО";
      break;
    case "banking_emulator":
      name = "Emulator";
      break;
    case "smartposmini":
      name = "APK Driver";
      break;
    case "portmone_QR":
      name = "Portmone.com QR pay";
      break;
    case "android_sumup_sdk":
      name = "SunIP EMV";
      break;
    case "android_ingenico_bpos_sdk_ua":
      name = "BPOS USB";
      break;
    case "android_ingenico_bpos_ip":
      name = "BPOS Ethernet/WiFi";
      break;
    case "android_ingenico_bpos_privatbank_sdk_ua":
      name = "PrivatBank BPOS USB";
      break;
    case "android_ingenico_bpos_privatbank_sdk_ua_tcpip":
      name = "PrivatBank BPOS Ethernet/WiFi";
      break;
    case "android_jsonbased_privatbank_usb":
      name = "PrivatBank json-based USB";
      break;
    case "android_jsonbased_privatbank_ip":
      name = "PrivatBank json-based Ethernet/WiFi";
      break;
    case "android_ingenico_bposlight_usb_2":
      name = "BposLight USB";
      break;
    case "android_ingenico_bposlight_ip_2":
      name = "BposLight Ethernet/WiFi";
      break;
    case "android_ingenico_bpos_sdk_ua_tcpip":
      name = "BPOS Ethernet/WiFi";
      break;
    case "android_ingenico_bpos_noprinter_sdk_ua_tcpip":
      name = "BPOS Ethernet/WiFi";
      break;
    case "android_ingenico_bpos_noprinter_privatbank_sdk_ua_tcpip":
      name = "PrivatBank BPOS Ethernet/WiFi";
      break;
    case "android_ingenico_smart_sdk_ua_2":
      name = "SDK Driver";
      break;
    case "android_verifone_usb_2":
      name = "USB SSI";
      break;
    case "windows_jsonbased_privatbank_ip":
      name = "Ethernet";
      break;
    case "android_verifone_ip":
      name = "Ethernet/WiFi SSI";
      break;
    case "android_verifone_ip_2":
      name = "Ethernet/WiFi SSI";
      break;
    case "android_jsonbased_privatbank_usb_pax":
      name = "PrivatBank json-based USB";
      break;
    case "android_jsonbased_privatbank_ip_pax":
      name = "PrivatBank json-based Ethernet/WiFi";
      break;
    case "windows_jsonbased_privatbank_com_pax":
      name = "PrivatBank json-based COM";
      break;
    case "android_privatreader_sdk":
      name = "Bluetooth";
      break;
    case "shtrih_m_weightserver":
      name = "Skyservice weight server";
      break;
    case "windows_shtrih_m_ip":
      name = "Ethernet/WiFi";
      break;
    case "cas_skyapp_libra":
      name = "Skyservice Desktop";
      break;
    case "cas_weightserver":
      name = "Skyservice weight server";
      break;
    case "ikc_skyapp_libra":
      name = "Skyservice Desktop";
      break;
    case "datalogic_weightserver":
      name = "Skyservice weight server";
      break;
    case "axis_weightserver":
      name = "Skyservice weight server";
      break;
    case "axis_skyapp_libra":
      name = "Skyservice Desktop";
      break;
    case "aurora_skyapp_libra":
      name = "Skyservice Desktop";
      break;
    case "cas_usb":
      name = "COM -> USB Adapter";
      break;
    case "cas_com":
      name = "COM (only jassway)";
      break;
    case "ikcweightandroid":
      name = "COM -> USB Adapter";
      break;
    case "axis_android_libra":
      name = "USB";
      break;
    case "aurora_android_libra_serial":
      name = "Serial (Only POS-terminal support)";
      break;
    case "aurora_android_libra_usb":
      name = "USB";
      break;
    case "scanner_datalogic_windows_com":
      name = "COM";
      break;
    case "poolserver1":
      name = "Poolserver v1.0";
      break;
    case "hallscreen_windows":
      name = i18n.global.t("hallscreen_windows");
      break;
    default:
      break;
  }
  return name;
}

function mutateWhatToPrint(e) {
  var name = "";
  switch (e) {
    case "1":
      name = i18n.global.t("OnlyRunners");
      break;
    case "2":
      name = i18n.global.t("CheckRunners");
      break;
    case "3":
      name = i18n.global.t("CheckOnly");
      break;
    case "4":
      name = i18n.global.t("OnlyLabels");
      break;
    case "5":
      name = i18n.global.t("RunnersChecks");
      break;
    default:
      break;
  }
  return name;
}

function mutatePromise(e) {
  var name = "";
  switch (e) {
    case "0":
      name = i18n.global.t("NotBlocking");
      break;
    case "1":
      name = i18n.global.t("blockTr");
      break;
    case "2":
      name = i18n.global.t("waitblocking");
      break;
    default:
      break;
  }
  return name;
}

function mutateChineseMode(e) {
  var name = "";
  switch (e) {
    case "0":
      name = i18n.global.t("SwitchedOn");
      break;
    case "1":
      name = i18n.global.t("SwitchedOff");
      break;
    default:
      break;
  }
  return name;
}

function mutateTransferMode(e) {
  var name = "";
  switch (e) {
    case "listener":
      name = i18n.global.t("listener");
      break;
    case "request":
      name = i18n.global.t("requestlibr");
      break;
    default:
      break;
  }
  return name;
}

// devices, пристрої

// flags, прапори

function getFlag(e) {
  var fl = "";
  switch (e) {
    case "Ukraine":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/4/49/Flag_of_Ukraine.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Ecuador":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/e/e8/Flag_of_Ecuador.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Thailand":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/a/a9/Flag_of_Thailand.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Peru":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/c/cf/Flag_of_Peru.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Mexico":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/f/fc/Flag_of_Mexico.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Morocco":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/2/2c/Flag_of_Morocco.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Philippines":
      fl =
        '<img src="https://upload.wikimedia.org/wikipedia/commons/9/99/Flag_of_the_Philippines.svg" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    case "Russian Federation":
      fl =
        '<img src="data:image/jpeg;base64,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" width="30">' +
        ' <span class="fw-normal"> ' +
        e +
        " </span> ";
      break;
    default:
      fl = ' <span class="fw-normal"> ' + e + " </span>";
      break;
  }
  return fl;
}

function getNameCountry(e) {
  var name = "";
  switch (e) {
    case "US":
      name = i18n.global.t("UnitedStatesLang");
      break;
    case "RU":
      // name = i18n.global.t('RussianFederationLang');
      name = "Рашка-парашка 💩";
      break;
    case "EG":
      name = i18n.global.t("EgyptLang");
      break;
    case "ZA":
      name = i18n.global.t("SouthAfricaLang");
      break;
    case "GR":
      name = i18n.global.t("GreeceLang");
      break;
    case "NL":
      name = i18n.global.t("NetherlandsLang");
      break;
    case "BE":
      name = i18n.global.t("BelgiumLang");
      break;
    case "FR":
      name = i18n.global.t("FranceLang");
      break;
    case "ES":
      name = i18n.global.t("SpainLang");
      break;
    case "HU":
      name = i18n.global.t("HungaryLang");
      break;
    case "IT":
      name = i18n.global.t("ItalyLang");
      break;
    case "RO":
      name = i18n.global.t("RomaniaLang");
      break;
    case "CH":
      name = i18n.global.t("SwitzerlandLang");
      break;
    case "AT":
      name = i18n.global.t("AustriaLang");
      break;
    case "GB":
      name = i18n.global.t("UnitedKingdomLang");
      break;
    case "DK":
      name = i18n.global.t("DenmarkLang");
      break;
    case "SE":
      name = i18n.global.t("SwedenLang");
      break;
    case "SJ":
      name = i18n.global.t("SvalbardandJanMayenLang");
      break;
    case "PL":
      name = i18n.global.t("PolandLang");
      break;
    case "DE":
      name = i18n.global.t("GermanyLang");
      break;
    case "PE":
      name = i18n.global.t("PeruLang");
      break;
    case "MX":
      name = i18n.global.t("MexicoLang");
      break;
    case "CU":
      name = i18n.global.t("CubaLang");
      break;
    case "AR":
      name = i18n.global.t("ArgentinaLang");
      break;
    case "BR":
      name = i18n.global.t("BrazilLang");
      break;
    case "CL":
      name = i18n.global.t("ChileLang");
      break;
    case "CO":
      name = i18n.global.t("ColombiaLang");
      break;
    case "VE":
      name = i18n.global.t("VenezuelaLang");
      break;
    case "MY":
      name = i18n.global.t("MalaysiaLang");
      break;
    case "CX":
      name = i18n.global.t("ChristmasIslandLang");
      break;
    case "ID":
      name = i18n.global.t("IndonesiaLang");
      break;
    case "PH":
      name = i18n.global.t("PhilippinesLang");
      break;
    case "NZ":
      name = i18n.global.t("NewZealandLang");
      break;
    case "SG":
      name = i18n.global.t("SingaporeLang");
      break;
    case "TH":
      name = i18n.global.t("ThailandLang");
      break;
    case "JP":
      name = i18n.global.t("JapanLang");
      break;
    case "KR":
      name = i18n.global.t("KoreaRepublicofLang");
      break;
    case "VN":
      name = i18n.global.t("VietnamLang");
      break;
    case "CN":
      name = i18n.global.t("ChinaLang");
      break;
    case "TR":
      name = i18n.global.t("TurkeyLang");
      break;
    case "IN":
      name = i18n.global.t("IndiaLang");
      break;
    case "PK":
      name = i18n.global.t("PakistanLang");
      break;
    case "AF":
      name = i18n.global.t("AfghanistanLang");
      break;
    case "LK":
      name = i18n.global.t("SriLankaLang");
      break;
    case "MM":
      name = i18n.global.t("MyanmarLang");
      break;
    case "IR":
      name = i18n.global.t("IranIslamicRepublicofLang");
      break;
    case "SS":
      name = i18n.global.t("SouthSudanLang");
      break;
    case "MA":
      name = i18n.global.t("MoroccoLang");
      break;
    case "DZ":
      name = i18n.global.t("AlgeriaLang");
      break;
    case "TN":
      name = i18n.global.t("TunisiaLang");
      break;
    case "LY":
      name = i18n.global.t("LibyanArabJamahiriyaLang");
      break;
    case "GM":
      name = i18n.global.t("GambiaLang");
      break;
    case "SN":
      name = i18n.global.t("SenegalLang");
      break;
    case "MR":
      name = i18n.global.t("MauritaniaLang");
      break;
    case "ML":
      name = i18n.global.t("MaliLang");
      break;
    case "GN":
      name = i18n.global.t("GuineaLang");
      break;
    case "CI":
      name = i18n.global.t("CotedIvoireLang");
      break;
    case "BF":
      name = i18n.global.t("BurkinaFasoLang");
      break;
    case "NE":
      name = i18n.global.t("NigerLang");
      break;
    case "TG":
      name = i18n.global.t("TogoLang");
      break;
    case "BJ":
      name = i18n.global.t("BeninLang");
      break;
    case "MU":
      name = i18n.global.t("MauritiusLang");
      break;
    case "LR":
      name = i18n.global.t("LiberiaLang");
      break;
    case "SL":
      name = i18n.global.t("SierraLeoneLang");
      break;
    case "GH":
      name = i18n.global.t("GhanaLang");
      break;
    case "NG":
      name = i18n.global.t("NigeriaLang");
      break;
    case "TD":
      name = i18n.global.t("ChadLang");
      break;
    case "CF":
      name = i18n.global.t("CentralAfricanRepublicLang");
      break;
    case "CM":
      name = i18n.global.t("CameroonLang");
      break;
    case "CV":
      name = i18n.global.t("CapeVerdeLang");
      break;
    case "ST":
      name = i18n.global.t("SaoTomeandPrincipeLang");
      break;
    case "GQ":
      name = i18n.global.t("EquatorialGuineaLang");
      break;
    case "GA":
      name = i18n.global.t("GabonLang");
      break;
    case "CG":
      name = i18n.global.t("CongoLang");
      break;
    case "CD":
      name = i18n.global.t("CongoDemocraticRepublicoftheLang");
      break;
    case "AO":
      name = i18n.global.t("AngolaLang");
      break;
    case "GW":
      name = i18n.global.t("GuineaBissauLang");
      break;
    case "IO":
      name = i18n.global.t("BritishIndianOceanTerritoryLang");
      break;
    case "SC":
      name = i18n.global.t("SeychellesLang");
      break;
    case "SD":
      name = i18n.global.t("SudanLang");
      break;
    case "RW":
      name = i18n.global.t("RwandaLang");
      break;
    case "ET":
      name = i18n.global.t("EthiopiaLang");
      break;
    case "SO":
      name = i18n.global.t("SomaliaLang");
      break;
    case "DJ":
      name = i18n.global.t("DjiboutiLang");
      break;
    case "KE":
      name = i18n.global.t("KenyaLang");
      break;
    case "TZ":
      name = i18n.global.t("TanzaniaUnitedRepublicOfLang");
      break;
    case "UG":
      name = i18n.global.t("UgandaLang");
      break;
    case "BI":
      name = i18n.global.t("BurundiLang");
      break;
    case "MZ":
      name = i18n.global.t("MozambiqueLang");
      break;
    case "ZM":
      name = i18n.global.t("ZambiaLang");
      break;
    case "MG":
      name = i18n.global.t("MadagascarLang");
      break;
    case "RE":
      name = i18n.global.t("ReunionLang");
      break;
    case "ZW":
      name = i18n.global.t("ZimbabweLang");
      break;
    case "NA":
      name = i18n.global.t("NamibiaLang");
      break;
    case "MW":
      name = i18n.global.t("MalawiLang");
      break;
    case "LS":
      name = i18n.global.t("LesothoLang");
      break;
    case "BW":
      name = i18n.global.t("BotswanaLang");
      break;
    case "SZ":
      name = i18n.global.t("SwazilandLang");
      break;
    case "KM":
      name = i18n.global.t("ComorosLang");
      break;
    case "SH":
      name = i18n.global.t("SaintHelenaAscensionAndTristanDaCunhaLang");
      break;
    case "ER":
      name = i18n.global.t("EritreaLang");
      break;
    case "AW":
      name = i18n.global.t("ArubaLang");
      break;
    case "FO":
      name = i18n.global.t("FaroeIslandsLang");
      break;
    case "GL":
      name = i18n.global.t("GreenlandLang");
      break;
    case "GI":
      name = i18n.global.t("GibraltarLang");
      break;
    case "PT":
      name = i18n.global.t("PortugalLang");
      break;
    case "LU":
      name = i18n.global.t("LuxembourgLang");
      break;
    case "IE":
      name = i18n.global.t("IrelandLang");
      break;
    case "IS":
      name = i18n.global.t("IcelandLang");
      break;
    case "AL":
      name = i18n.global.t("AlbaniaLang");
      break;
    case "MT":
      name = i18n.global.t("MaltaLang");
      break;
    case "CY":
      name = i18n.global.t("CyprusLang");
      break;
    case "FI":
      name = i18n.global.t("FinlandLang");
      break;
    case "BG":
      name = i18n.global.t("BulgariaLang");
      break;
    case "LT":
      name = i18n.global.t("LithuaniaLang");
      break;
    case "LV":
      name = i18n.global.t("LatviaLang");
      break;
    case "EE":
      name = i18n.global.t("EstoniaLang");
      break;
    case "MD":
      name = i18n.global.t("MoldovaLang");
      break;
    case "AM":
      name = i18n.global.t("ArmeniaLang");
      break;
    case "BY":
      name = i18n.global.t("BelarusLang");
      break;
    case "AD":
      name = i18n.global.t("AndorraLang");
      break;
    case "MC":
      name = i18n.global.t("MonacoLang");
      break;
    case "SM":
      name = i18n.global.t("SanMarinoLang");
      break;
    case "VA":
      name = i18n.global.t("HolySeeVaticanCityStateLang");
      break;
    case "UA":
      name = i18n.global.t("UkraineLang");
      break;
    case "RS":
      name = i18n.global.t("SerbiaLang");
      break;
    case "ME":
      name = i18n.global.t("MontenegroLang");
      break;
    case "HR":
      name = i18n.global.t("CroatiaLang");
      break;
    case "SI":
      name = i18n.global.t("SloveniaLang");
      break;
    case "BA":
      name = i18n.global.t("BosniaandHerzegovinaLang");
      break;
    case "MK":
      name = i18n.global.t("MacedoniaTheFormerYugoslavRepublicOfLang");
      break;
    case "CZ":
      name = i18n.global.t("CzechRepublicLang");
      break;
    case "SK":
      name = i18n.global.t("SlovakiaLang");
      break;
    case "LI":
      name = i18n.global.t("LiechtensteinLang");
      break;
    case "FK":
      name = i18n.global.t("FalklandIslandsMalvinasLang");
      break;
    case "BZ":
      name = i18n.global.t("BelizeLang");
      break;
    case "GT":
      name = i18n.global.t("GuatemalaLang");
      break;
    case "SV":
      name = i18n.global.t("ElSalvadorLang");
      break;
    case "HN":
      name = i18n.global.t("HondurasLang");
      break;
    case "NI":
      name = i18n.global.t("NicaraguaLang");
      break;
    case "CR":
      name = i18n.global.t("CostaRicaLang");
      break;
    case "PA":
      name = i18n.global.t("PanamaLang");
      break;
    case "PM":
      name = i18n.global.t("SaintPierreandMiquelonLang");
      break;
    case "HT":
      name = i18n.global.t("HaitiLang");
      break;
    case "MF":
      name = i18n.global.t("SaintMartinFrenchPartLang");
      break;
    case "BO":
      name = i18n.global.t("BoliviaplurinationalstateofLang");
      break;
    case "GY":
      name = i18n.global.t("GuyanaLang");
      break;
    case "EC":
      name = i18n.global.t("EcuadorLang");
      break;
    case "GF":
      name = i18n.global.t("FrenchGuianaLang");
      break;
    case "PY":
      name = i18n.global.t("ParaguayLang");
      break;
    case "MQ":
      name = i18n.global.t("MartiniqueLang");
      break;
    case "SR":
      name = i18n.global.t("SurinameLang");
      break;
    case "UY":
      name = i18n.global.t("UruguayLang");
      break;
    case "SX":
      name = i18n.global.t("SintMaartenLang");
      break;
    case "TL":
      name = i18n.global.t("TimorLesteLang");
      break;
    case "NF":
      name = i18n.global.t("NorfolkIslandLang");
      break;
    case "BN":
      name = i18n.global.t("BruneiDarussalamLang");
      break;
    case "NR":
      name = i18n.global.t("NauruLang");
      break;
    case "PG":
      name = i18n.global.t("PapuaNewGuineaLang");
      break;
    case "TO":
      name = i18n.global.t("TongaLang");
      break;
    case "SB":
      name = i18n.global.t("SolomonIslandsLang");
      break;
    case "VU":
      name = i18n.global.t("VanuatuLang");
      break;
    case "FJ":
      name = i18n.global.t("FijiLang");
      break;
    case "PW":
      name = i18n.global.t("PalauLang");
      break;
    case "WF":
      name = i18n.global.t("WallisandFutunaLang");
      break;
    case "CK":
      name = i18n.global.t("CookIslandsLang");
      break;
    case "NU":
      name = i18n.global.t("NiueLang");
      break;
    case "WS":
      name = i18n.global.t("SamoaLang");
      break;
    case "KI":
      name = i18n.global.t("KiribatiLang");
      break;
    case "NC":
      name = i18n.global.t("NewCaledoniaLang");
      break;
    case "TV":
      name = i18n.global.t("TuvaluLang");
      break;
    case "PF":
      name = i18n.global.t("FrenchPolynesiaLang");
      break;
    case "TK":
      name = i18n.global.t("TokelauLang");
      break;
    case "FM":
      name = i18n.global.t("MicronesiaFederatedStatesofLang");
      break;
    case "MH":
      name = i18n.global.t("MarshallIslandsLang");
      break;
    case "KP":
      name = i18n.global.t("KoreaDemocraticPeoplesrepublicofLang");
      break;
    case "HK":
      name = i18n.global.t("HongKongLang");
      break;
    case "MO":
      name = i18n.global.t("MacaoLang");
      break;
    case "KH":
      name = i18n.global.t("CambodiaLang");
      break;
    case "LA":
      name = i18n.global.t("LaoPeoplesDemocraticRepublicLang");
      break;
    case "PN":
      name = i18n.global.t("PitcairnLang");
      break;
    case "BD":
      name = i18n.global.t("BangladeshLang");
      break;
    case "TW":
      name = i18n.global.t("TaiwanProvinceofChinaLang");
      break;
    case "MV":
      name = i18n.global.t("MaldivesLang");
      break;
    case "LB":
      name = i18n.global.t("LebanonLang");
      break;
    case "JO":
      name = i18n.global.t("JordanLang");
      break;
    case "SY":
      name = i18n.global.t("SyrianArabRepublicLang");
      break;
    case "IQ":
      name = i18n.global.t("IraqLang");
      break;
    case "KW":
      name = i18n.global.t("KuwaitLang");
      break;
    case "SA":
      name = i18n.global.t("SaudiArabiaLang");
      break;
    case "YE":
      name = i18n.global.t("YemenLang");
      break;
    case "OM":
      name = i18n.global.t("OmanLang");
      break;
    case "PS":
      name = i18n.global.t("PalestinianTerritoryOccupiedLang");
      break;
    case "AE":
      name = i18n.global.t("UnitedArabEmiratesLang");
      break;
    case "IL":
      name = i18n.global.t("IsraelLang");
      break;
    case "BH":
      name = i18n.global.t("BahrainLang");
      break;
    case "QA":
      name = i18n.global.t("QatarLang");
      break;
    case "BT":
      name = i18n.global.t("BhutanLang");
      break;
    case "MN":
      name = i18n.global.t("MongoliaLang");
      break;
    case "NP":
      name = i18n.global.t("NepalLang");
      break;
    case "TJ":
      name = i18n.global.t("TajikistanLang");
      break;
    case "TM":
      name = i18n.global.t("TurkmenistanLang");
      break;
    case "AZ":
      name = i18n.global.t("AzerbaijanLang");
      break;
    case "GE":
      name = i18n.global.t("GeorgiaLang");
      break;
    case "KG":
      name = i18n.global.t("KyrgyzstanLang");
      break;
    case "UZ":
      name = i18n.global.t("UzbekistanLang");
      break;
    case "BS":
      name = i18n.global.t("BahamasLang");
      break;
    case "BB":
      name = i18n.global.t("BarbadosLang");
      break;
    case "AI":
      name = i18n.global.t("AnguillaLang");
      break;
    case "AG":
      name = i18n.global.t("AntiguaandBarbudaLang");
      break;
    case "VG":
      name = i18n.global.t("VirginIslandsBritishLang");
      break;
    case "VI":
      name = i18n.global.t("VirginIslandsUSLang");
      break;
    case "KY":
      name = i18n.global.t("CaymanIslandsLang");
      break;
    case "BM":
      name = i18n.global.t("BermudaLang");
      break;
    case "GD":
      name = i18n.global.t("GrenadaLang");
      break;
    case "TC":
      name = i18n.global.t("TurksandCaicosIslandsLang");
      break;
    case "MS":
      name = i18n.global.t("MontserratLang");
      break;
    case "MP":
      name = i18n.global.t("NorthernMarianaIslandsLang");
      break;
    case "GU":
      name = i18n.global.t("GuamLang");
      break;
    case "AS":
      name = i18n.global.t("AmericanSamoaLang");
      break;
    case "LC":
      name = i18n.global.t("SaintLuciaLang");
      break;
    case "DM":
      name = i18n.global.t("DominicaLang");
      break;
    case "VC":
      name = i18n.global.t("SaintVincentandtheGrenadinesLang");
      break;
    case "PR":
      name = i18n.global.t("PuertoRicoLang");
      break;
    case "DO":
      name = i18n.global.t("DominicanRepublicLang");
      break;
    case "TT":
      name = i18n.global.t("TrinidadandTobagoLang");
      break;
    case "KN":
      name = i18n.global.t("SaintKittsandNevisLang");
      break;
    case "JM":
      name = i18n.global.t("JamaicaLang");
      break;
    case "AX":
      name = i18n.global.t("AlandIslandsLang");
      break;
    case "GG":
      name = i18n.global.t("GuernseyLang");
      break;
    case "JE":
      name = i18n.global.t("JerseyLang");
      break;
    case "IM":
      name = i18n.global.t("IsleofManLang");
      break;
    case "CA":
      name = i18n.global.t("CanadaLang");
      break;
    case "KZ":
      name = i18n.global.t("QazaqstanRespyblikasyLang");
      break;

    default:
      name = "невідомо";
      break;
  }
  return name;
}

// flags, прапори

// accounts, акаунти

function mutateWorkerPosition(e) {
  var name = "";
  switch (e) {
    case "admin":
      name = i18n.global.t("admin");
      break;
    case "seller":
      name = i18n.global.t("seller");
      break;
    case "waiter":
      name = i18n.global.t("waiter");
      break;
    case "bartender":
      name = i18n.global.t("bartender");
      break;
    case "chef":
      name = i18n.global.t("chef");
      break;
    case "courier":
      name = i18n.global.t("courier");
      break;
    case "hairdresser":
      name = i18n.global.t("hairdresser");
      break;
    case "beautician":
      name = i18n.global.t("beautician");
      break;
    case "masseur":
      name = i18n.global.t("masseur");
      break;
    case "mastermanicurepedicure":
      name = i18n.global.t("mastermanicurepedicure");
      break;
    case "depilationmaster":
      name = i18n.global.t("depilationmaster");
      break;
    case "owner":
      name = i18n.global.t("owner");
      break;

    default:
      name = i18n.global.t("user");
      break;
  }
  return name;
}

function mutateStatusAccounts(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "1":
      name = i18n.global.t("statusNew");
      color = "badge bg-info";
      break;
    case "2":
      name = i18n.global.t("firstContact");
      color = "badge bg-info";
      break;
    case "3":
      name = i18n.global.t("Cold");
      color = "badge bg-secondary";
      break;
    case "4":
      name = i18n.global.t("Warm");
      color = "badge bg-success";
      break;
    case "5":
      name = i18n.global.t("Hot");
      color = "badge bg-success";
      break;
    case "6":
      name = i18n.global.t("Refused");
      color = "badge bg-danger";
      break;
    case "7":
      name = i18n.global.t("usesPoster");
      color = "badge bg-danger";
      break;
    case "8":
      name = i18n.global.t("usesSmarttouch");
      color = "badge bg-danger";
      break;
    case "9":
      name = i18n.global.t("usesTrinipos");
      color = "badge bg-danger";
      break;
    case "10":
      name = i18n.global.t("usesCloudPOS");
      color = "badge bg-danger";
      break;
    case "11":
      name = i18n.global.t("usesPOS");
      color = "badge bg-danger";
      break;
    case "12":
      name = i18n.global.t("uses1c");
      color = "badge bg-danger";
      break;
    case "13":
      name = i18n.global.t("useskeeper");
      color = "badge bg-danger";
      break;
    case "14":
      name = i18n.global.t("usesiiko");
      color = "badge bg-danger";
      break;
    case "15":
      name = i18n.global.t("usesQuickResto");
      color = "badge bg-danger";
      break;
    case "16":
      name = i18n.global.t("notRegistered");
      color = "badge bg-warning";
      break;
    case "17":
      name = i18n.global.t("tryResurrect");
      color = "badge bg-warning";
      break;
    case "18":
      name = i18n.global.t("OldClient");
      color = "badge bg-warning";
      break;
  }
  return { name, color };
}

function mutatePriorityAccounts(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "2":
      name = i18n.global.t("priorityHigh");
      color = "badge bg-danger";
      break;
    case "1":
      name = i18n.global.t("priorityMedium");
      color = "badge bg-warning";
      break;
    case "0":
      name = i18n.global.t("priorityLow");
      color = "badge bg-success";
      break;
  }
  return { name, color };
}

function mutateWorkersAccount(e) {
  // статус співробітника
  var name = "";
  var color = "";
  var bgcolor = "";
  switch (e) {
    case true:
      name = i18n.global.t("active_user");
      color = "badge bg-success";
      bgcolor = "bg-success";
      break;
    case false:
      name = i18n.global.t("blocked_user");
      color = "badge bg-warning";
      bgcolor = "bg-warning";
      break;
    case 1:
      name = i18n.global.t("active_user");
      color = "badge bg-success";
      bgcolor = "bg-success";
      break;
    case 0:
      name = i18n.global.t("blocked_user");
      color = "badge bg-danger";
      bgcolor = "bg-danger";
      break;
    case "removed":
      name = i18n.global.t("removedev");
      color = "badge bg-danger";
      bgcolor = "bg-danger";
      break;
  }
  return { name, color, bgcolor };
}

function mutateDirWorker(e) {
  var name = "";
  switch (e) {
    case "dashboard":
      name = i18n.global.t("dir_dashboard");
      break;
    case "reports":
      name = i18n.global.t("dir_reports");
      break;
    case "pos":
      name = i18n.global.t("dir_pos");
      break;
    case "pos-new":
      name = i18n.global.t("dir_posnew");
      break;
  }
  return name;
}

function mutateWorkerAllAccountFormRight(e) {
  var name = "";
  var color = "";
  switch (e) {
    case true:
      name = i18n.global.t("admin");
      color = "bg-info";
      break;
    case false:
      name = i18n.global.t("Employee");
      color = "bg-warning";
      break;
  }
  return { name, color };
}

function mutateUserCompanies(e) {
  // перевірка на адміна в компанії
  var name = "";
  switch (e) {
    case true:
      name = i18n.global.t("owner_of_company");
      break;
    case false:
      name = i18n.global.t("Employee");
      break;
  }
  return name;
}

function mutateCommentsAcc(e, obj) {
  // комент до зареєстрованого акаунта
  var name = "";
  switch (e) {
    case "new":
      name =
        obj.action != ""
          ? i18n.global.t("newRegister") +
            " + " +
            i18n.global.t("CreatedCompany")
          : i18n.global.t("newRegister");
      break;
    case "old":
      name =
        obj.action != ""
          ? i18n.global.t("oldRegister") +
            " + " +
            i18n.global.t("CreatedCompany")
          : i18n.global.t("oldRegister");
      break;
  }
  return name;
}

function mutateStatusDel(e, obj) {
  // статус акаунту на видалення
  var name = "";
  var color = "";
  switch (e) {
    case true:
      name = i18n.global.t("Delete");
      color = "badge bg-danger";
      break;
    case false:
      name =
        i18n.global.t("afterDay") +
        " " +
        obj.daysLeft +
        " " +
        i18n.global.t("days");
      color = "badge bg-info";
      break;
  }
  return { name, color };
}

// accounts, акаунти

// other setting in account, інші налаштування в акаунті

function mutateDomainSkyMarket(e) {
  // тип домена
  var name = "";
  switch (e) {
    case "subdomain":
      name = i18n.global.t("ourDomain");
      break;
    case "mydomain":
      name = i18n.global.t("ClientDomain");
      break;
  }
  return name;
}

function mutateTariffingOutlets(e) {
  // тарифікація точки
  var name = "";
  var color = "";
  switch (e) {
    case "tariffed":
      name = i18n.global.t("Charged");
      color = "badge bg-success";
      break;
    case "Tariffed":
      name = i18n.global.t("Charged");
      color = "badge bg-success";
      break;
    case "Not Tariffed":
      name = i18n.global.t("Not_charged");
      color = "badge bg-danger";
      break;
    case "nontariffed":
      name = i18n.global.t("Not_charged");
      color = "badge bg-danger";
      break;
    case "removed":
      name = i18n.global.t("Removed");
      color = "badge bg-danger";
      break;
    case "frozen":
      name = i18n.global.t("Frozen");
      color = "badge bg-info";
      break;
    default:
      name = i18n.global.t("Removed");
      color = "badge bg-danger";
      break;
  }
  return { name, color };
}

function mutateServerSyncOutlets(e) {
  var check = "";
  switch (e) {
    case true:
      check = "✅";
      break;
    case false:
      check = "❌";
      break;
  }
  return check;
}

function mutateConnectStatus(e) {
  // статус налаштування підключення
  var name = "";
  var color = "";
  switch (e) {
    case "active":
      name = i18n.global.t("active");
      color = "badge bg-success";
      break;
    case "noactive":
      name = i18n.global.t("noactive");
      color = "badge bg-danger";
      break;
  }
  return { name, color };
}

function mutateTypeHistoryAcc(e) {
  // тип документа в історія карти клієнта
  var name = "";
  var color = "";
  switch (e) {
    case "monitoring":
      name = i18n.global.t("monitoringLabel");
      color = "badge bg-success";
      break;
    case "request":
      name = i18n.global.t("Application");
      color = "badge bg-info";
      break;
    case "coldCall":
      name = i18n.global.t("Cold");
      color = "badge bg-info";
      break;
    case "presentation":
      name = i18n.global.t("presentation");
      color = "badge bg-secondary";
      break;
    case "task":
      name = i18n.global.t("Task");
      color = "badge bg-warning";
      break;
    case "ticket":
      name = i18n.global.t("ticket");
      color = "badge bg-danger";
      break;
    case "dump":
      name = i18n.global.t("dump");
      color = "badge bg-info";
      break;
    case "call":
      name = i18n.global.t("call");
      color = "badge bg-info";
      break;
    case "requestByCall":
      name = i18n.global.t("call");
      color = "badge bg-info";
      break;
    default:
      name = "Щось цікаве";
      color = "primary";
  }
  return { name, color };
}

function mutatePayPayments(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "success":
      name = i18n.global.t("status_pay_success");
      color = "badge badge-soft-success";
      break;
    case "error":
      name = i18n.global.t("status_pay_error");
      color = "badge badge-soft-danger";
      break;
    case "failure":
      name = i18n.global.t("status_pay_failure");
      color = "badge badge-soft-danger";
      break;
    case "reversed":
      name = i18n.global.t("status_pay_reversed");
      color = "badge badge-soft-primary";
      break;
    case "subscribed":
      name = i18n.global.t("status_pay_subscribed");
      color = "badge badge-soft-success";
      break;
    case "unsubscribed":
      name = i18n.global.t("status_pay_unsubscribed");
      color = "badge badge-soft-danger";
      break;
    case "cash_wait":
      name = i18n.global.t("status_pay_cash_wait");
      color = "badge badge-soft-warning";
      break;
    case "hold_wait":
      name = i18n.global.t("status_pay_hold_wait");
      color = "badge badge-soft-warning";
      break;
    case "invoice_wait":
      name = i18n.global.t("status_pay_invoice_wait");
      color = "badge badge-soft-warning";
      break;
    case "prepared":
      name = i18n.global.t("status_pay_prepared");
      color = "badge badge-soft-warning";
      break;
    case "processing":
      name = i18n.global.t("status_pay_processing");
      color = "badge badge-soft-warning";
      break;
    case "wait_accept":
      name = i18n.global.t("status_pay_wait_accept");
      color = "badge badge-soft-warning";
      break;
    case "wait_card":
      name = i18n.global.t("status_pay_wait_card");
      color = "badge badge-soft-warning";
      break;
    case "wait_compensation":
      name = i18n.global.t("status_pay_wait_compensation");
      color = "badge badge-soft-warning";
      break;
    case "wait_lc":
      name = i18n.global.t("status_pay_wait_lc");
      color = "badge badge-soft-warning";
      break;
    case "wait_reserve":
      name = i18n.global.t("status_pay_wait_reserve");
      color = "badge badge-soft-warning";
      break;
    case "wait_secure":
      name = i18n.global.t("status_pay_wait_secure");
      color = "badge badge-soft-warning";
      break;
    case "try_again":
      name = i18n.global.t("status_pay_try_again");
      color = "badge badge-soft-danger";
      break;
  }
  return { name, color };
}

function mutatePayPickupSkyMarket(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "cash":
      name = i18n.global.t("CashPayment");
      color = "success";
      break;
    case "cardPayment":
      name = i18n.global.t("CardPaymentEst");
      color = "danger";
      break;
    case "cashOnDelivery":
      name = i18n.global.t("cashOnDelivery");
      color = "warning";
      break;
  }
  return { name, color };
}

function mutateBusiness(e) {
  var name = "";
  switch (e) {
    case "bar": {
      name = i18n.global.t("bar_title");
      break;
    }
    case "cafe": {
      name = i18n.global.t("Cafe_title");
      break;
    }
    case "coffeeshop": {
      name = i18n.global.t("coffee_shop_title");
      break;
    }
    case "restaurant": {
      name = i18n.global.t("restaurant_title");
      break;
    }
    case "canteen": {
      name = i18n.global.t("Canteen");
      break;
    }
    case "pizzeria": {
      name = i18n.global.t("Pizzeria");
      break;
    }
    case "sushibar": {
      name = i18n.global.t("sushibar");
      break;
    }
    case "fastfood": {
      name = i18n.global.t("fastfood");
      break;
    }
    case "foodtruck": {
      name = i18n.global.t("foodtruck");
      break;
    }
    case "hookah": {
      name = i18n.global.t("Hookah");
      break;
    }
    case "kiosk": {
      name = i18n.global.t("kiosk");
      break;
    }
    case "boutique": {
      name = i18n.global.t("boutique");
      break;
    }
    case "market": {
      name = i18n.global.t("market");
      break;
    }
    case "shop": {
      name = i18n.global.t("shop");
      break;
    }
    case "jewshop": {
      name = i18n.global.t("jewshop");
      break;
    }
    case "petshop": {
      name = i18n.global.t("petshop");
      break;
    }
    case "pharmacy": {
      name = i18n.global.t("pharmacy");
      break;
    }
    case "bakery": {
      name = i18n.global.t("bakery");
      break;
    }
    case "candyshop": {
      name = i18n.global.t("candyshop");
      break;
    }
    case "business": {
      name = i18n.global.t("business");
      break;
    }
    case "franchise": {
      name = i18n.global.t("franchise");
      break;
    }
    case "deliveryfood": {
      name = i18n.global.t("deliveryfood");
      break;
    }
    case "tirefitting": {
      name = i18n.global.t("tirefitting");
      break;
    }
    case "carwash": {
      name = i18n.global.t("carwash");
      break;
    }
    case "hospital": {
      name = i18n.global.t("hospital");
      break;
    }
    case "dentistry": {
      name = i18n.global.t("dentistry");
      break;
    }
    case "spasalon": {
      name = i18n.global.t("spasalon");
      break;
    }
    case "beautysaloon": {
      name = i18n.global.t("beautysaloon");
      break;
    }
    case "barbershop": {
      name = i18n.global.t("barbershop");
      break;
    }
    case "nailsalon": {
      name = i18n.global.t("nailsalon");
      break;
    }
    case "cosmetology": {
      name = i18n.global.t("cosmetology");
      break;
    }
  }
  return name;
}

function mutateActivity(e) {
  var name = "";
  switch (e) {
    case "institutions": {
      name = i18n.global.t("Institutions");
      break;
    }
    case "trade": {
      name = i18n.global.t("Trade");
      break;
    }
    case "production": {
      name = i18n.global.t("Production");
      break;
    }
    case "services": {
      name = i18n.global.t("Services");
      break;
    }
    default: {
      name = "-";
      break;
    }
  }
  return name;
}

function mutateTypeFound(e) {
  var name = "";
  switch (e) {
    case "recommendation": {
      name = i18n.global.t("Recommendation");
      break;
    }
    case "himself": {
      name = i18n.global.t("independently");
      break;
    }
    case "movedadvert": {
      name = i18n.global.t("MovedAdvertisement");
      break;
    }
    case "integrator": {
      name = i18n.global.t("ThroughIntegrator");
      break;
    }
    case "socialnetworks": {
      name = i18n.global.t("sawSocialNetworks");
      break;
    }
  }
  return name;
}

// other setting in account, інші налаштування в акаунті

// sale, inv, рахунки

function mutateStatusInv(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "pendingpay":
      name = i18n.global.t("pendingpay");
      color = "badge badge-soft-warning";
      break;
    case "paid":
      name = i18n.global.t("paidpay");
      color = "badge badge-soft-success";
      break;
    case "annul":
      name = i18n.global.t("annul");
      color = "badge badge-soft-danger";
      break;
    case "canceled":
      name = i18n.global.t("Canceled");
      color = "badge badge-soft-danger";
      break;
  }
  return { name, color };
}

function mutateProviderInv(e) {
  var name = "";
  switch (e) {
    case "FOP":
      name = i18n.global.t("FOp");
      break;
    case "TOV":
      name = i18n.global.t("TOv");
      break;
    case "fop":
      name = i18n.global.t("FOp");
      break;
    case "tov":
      name = i18n.global.t("TOv");
      break;
  }
  return name;
}

// sale, inv, рахунки

// services, послуги

function mutateServices(e) {
  var name = "";
  switch (e) {
    case "prro_setting":
      name = i18n.global.t("prro_setting");
      break;
    case "data_recovery":
      name = i18n.global.t("data_recovery");
      break;
    case "connecting_printer":
      name = i18n.global.t("connecting_printer");
      break;
    case "terminal_connection":
      name = i18n.global.t("terminal_connection");
      break;
  }
  return name;
}

function mutateStatusServices(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "problem_solved":
      name = i18n.global.t("problem_solved");
      color = "badge bg-success";
      break;
    case "problem_not_solved":
      name = i18n.global.t("problem_not_solved");
      color = "badge bg-danger";
      break;
  }
  return { name, color };
}

// services, послуги

// requests, заявки

// requests, заявки

// tasks, завдання

function mutateTypeTask(e) {
  var name = "";
  switch (e) {
    case "discharge_password":
      name = i18n.global.t("password_reset");
      break;
    case "repair_tt":
      name = i18n.global.t("tt_recovery");
      break;
    case "administrator_change":
      name = i18n.global.t("administrator_change");
      break;
    case "clear_stats":
      name = i18n.global.t("clearing_statistics");
      break;
    case "clearing_products":
      name = i18n.global.t("clearing_products");
      break;
    case "clearing_account":
      name = i18n.global.t("clearing_account");
      break;
    case "account_deleting":
      name = i18n.global.t("account_deleting");
      break;
    case "copy_data_franchise":
      name = i18n.global.t("copying_data_franchise");
      break;
    case "copying_data_inside":
      name = i18n.global.t("copying_data_inside");
      break;
    case "restoring_expense_categories":
      name = i18n.global.t("restoring_expense_categories");
      break;
    case "removing_the_customer_database":
      name = i18n.global.t("removing_the_customer_database");
      break;
    case "add_change_domain":
      name = i18n.global.t("add_change_domain");
      break;
    case "add_change_domain_newskymarket":
      name = i18n.global.t("add_change_domain_newskymarket");
      break;
    case "syncmode":
      name = i18n.global.t("SyncMode");
      break;
    case "multimode":
      name = i18n.global.t("MultiMode");
      break;
    case "change_limit_companies":
      name = i18n.global.t("ChangeLimitCompanies");
      break;
    case "enable_new_version":
      name = i18n.global.t("EnablenewVersion");
      break;
    case "receiving_token":
      name = i18n.global.t("ReceivingTokenfromPrivatBank");
      break;
    case "change_account_type":
      name = i18n.global.t("ChangeAccountType");
      break;
    case "strenght_switch_owner_of_comp":
      name = i18n.global.t("strenght_switch_owner_of_comp");
      break;
    case "strenght_switch_owner_of_acc":
      name = i18n.global.t("strenght_switch_owner_of_acc");
      break;
    case "restoration_expense_category":
      name = i18n.global.t("RestorationExpenseCategory");
      break;
    case "trans_data_from_old_company_franchise":
      name = i18n.global.t("trans_data_from_old_company_franchise");
      break;
    case "trans_data_from_old_company":
      name = i18n.global.t("trans_data_from_old_company");
      break;
    case "transfer_funds_companies_in_account":
      name = i18n.global.t("transfer_funds_companies_in_account");
      break;
    case "transfer_funds_companies_between_accounts":
      name = i18n.global.t("transfer_funds_companies_between_accounts");
      break;
    case "enable_old_version":
      name = i18n.global.t("EnableOldVersion");
      break;
    case "trans_data_from_newServer_company":
      name = i18n.global.t("trans_data_from_newServer_company");
      break;
    case "trans_data_from_newServer_company_franchise":
      name = i18n.global.t("trans_data_from_newServer_company_franchise");
      break;
    default:
      name = "-";
  }
  return name;
}

function formatDateString(inputDateString) {
  const months = [
    i18n.global.t("confJanuary"),
    i18n.global.t("confFebruary"),
    i18n.global.t("confMarch"),
    i18n.global.t("confApril"),
    i18n.global.t("confMay"),
    i18n.global.t("confJune"),
    i18n.global.t("confJuly"),
    i18n.global.t("confAugust"),
    i18n.global.t("confSeptember"),
    i18n.global.t("confOctober"),
    i18n.global.t("confNovember"),
    i18n.global.t("confDecember"),
  ];

  const dateParts = inputDateString.split("-");
  const day = parseInt(dateParts[2], 10);
  const monthIndex = parseInt(dateParts[1], 10) - 1; // Місяці в JavaScript починаються з 0

  if (!isNaN(day) && !isNaN(monthIndex) && months[monthIndex]) {
    return `${i18n.global.t("AwaitingExecution")} ${day} ${months[monthIndex]}`;
  }

  // Якщо введена дата некоректна, повертаємо той самий рядок
  return inputDateString;
}

function mutateStatusTask(e, obj) {
  var name = "";
  var color = "";

  function getDateFromDate(dateTime) {
    var date = new Date(dateTime);
    var dateStr =
      date.getFullYear() +
      "-" +
      ("00" + (date.getMonth() + 1)).slice(-2) +
      "-" +
      ("00" + date.getDate()).slice(-2);
    return dateStr;
  }

  switch (e) {
    case "confirmed":
      if (obj && obj.confirmed && obj.confirmed.datetime) {
        // Якщо дата та час вже пройшли, виводимо "Виконати терміново" todo dev
        if (new Date(obj.confirmed.datetime) < new Date()) {
          name = i18n.global.t("AwaitingExecution");
          color = "badge badge-soft-success";
        } else {
          // Якщо дата та час ще не настали, виводимо "Очікує на виконання + дата та час"
          name =
            formatDateString(getDateFromDate(obj.confirmed.datetime)) +
            " " +
            obj.confirmed.datetime.split(" ")[1];
          color = "badge badge-soft-warning";
        }
      } else {
        name = i18n.global.t("Confirmed");
        color = "badge badge-soft-success";
      }
      break;
    case "perform":
      name =
        obj && obj.perform
          ? i18n.global.t("inJobWorker") + " " + obj.perform.workerName
          : i18n.global.t("inJobWorker");
      color = "badge badge-soft-info";
      break;
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge badge-soft-info";
      break;
    case "rescheduled":
      name = i18n.global.t("statusrescheduled");
      color = "badge badge-soft-secondary";
      break;
    case "wait_confirm":
      name = i18n.global.t("waiting_confirmation");
      color = "badge badge-soft-danger";
      break;
    case "wait_completed":
      if (obj && obj.executionDatetime) {
        name = i18n.global.t("AwaitingExecution") + " " + obj.executionDatetime;
        color = "badge badge-soft-warning";
      } else {
        name = i18n.global.t("waiting_completed");
        color = "badge badge-soft-info";
      }
      break;
    case "jobs":
      name =
        obj && obj.inJob
          ? i18n.global.t("inJobWorker") + " " + obj.inJob.workerName
          : i18n.global.t("inJobWorker");
      color = "badge badge-soft-success";
      break;
    case "transfered":
      name = obj.transfer.workerName
        ? i18n.global.t("threw") + " " + obj.transfer.workerName
        : i18n.global.t("threw");
      color = "badge badge-soft-warning";
      break;
    case "Executed":
      name = i18n.global.t("Executed");
      color = "badge badge-soft-info";
      break;
    case "completed":
      name = i18n.global.t("performedT");
      color = "badge badge-soft-success";
      break;
    case "canceled":
      name = i18n.global.t("canceled");
      color = "badge badge-soft-danger";
      break;
    case "deleted":
      name = i18n.global.t("statuswait_delete");
      color = "badge badge-soft-danger";
      break;
    case "delayed":
      name = i18n.global.t("DelayedOnTime") + " " + obj.delayed.datetime;
      color = "badge badge-soft-warning";
      break;
  }
  return { name, color };
}

// tasks, завдання

function nameWorker(item) {
  var name = "";
  storeS.workers.forEach((el) => {
    if (el.workerId === item) {
      name = el.workerName;
    }
  });
  if (name == "") {
    name = i18n.global.t("notFoundWorker");
  }
  return name;
}

// tickets, тикети

function mutateStatus(e, obj) {
  var name = "";
  var color = "";
  switch (e) {
    case "inProgressNow":
      name = i18n.global.t("inProgressNow");
      color = "badge badge-soft-danger";
      break;
    case "callNow":
      name = i18n.global.t("CallNow");
      color = "badge badge-soft-danger";
      break;
    case "deleted":
      name = i18n.global.t("Removed");
      color = "badge badge-soft-danger";
      break;
    case "delayed":
      name = obj.delayedDatetime
        ? i18n.global.t("PostponedUntil") + " " + obj.delayedDatetime
        : i18n.global.t("PostponedUntil");
      color = "badge badge-soft-warning";
      break;
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge badge-soft-info";
      break;
    case "jobs":
      name =
        i18n.global.t("statusInWork") + " " + nameWorker(obj.inJobWorkerId);
      color = "badge badge-soft-success";
      break;
    case "wait_comment":
      name = obj.inJobWorkerName
        ? i18n.global.t("wait_comment") + " " + obj.inJobWorkerName
        : i18n.global.t("wait_comment");
      color = "badge badge-soft-info";
      break;
    case "canceled":
      name = i18n.global.t("canceled");
      color = "badge badge-soft-danger";
      break;
    case "wait_cancel":
      name = i18n.global.t("statuswait_delete");
      color = "badge badge-soft-primary";
      break;
    case "closed":
      name = i18n.global.t("closed");
      color = "badge badge-soft-info";
      break;
    case "transfered":
      name = i18n.global.t("threw") + " " + obj.transferedWorkerName;
      color = "badge badge-soft-warning";
      break;
  }
  return { name, color };
}

function mutateTypeTicket(e) {
  var name = "";
  switch (e) {
    case "problem":
      name = i18n.global.t("problem_to_develop");
      break;
    case "wishes":
      name = i18n.global.t("wish_to_develop");
      break;
  }
  return name;
}

function mutatePriorityOther(e) {
  var name = "";
  var color = "";
  var oc = "";
  switch (e) {
    case 2:
      name = i18n.global.t("priorityHigh");
      color = "badge-soft-danger";
      oc = "badge bg-danger";
      break;
    case 1:
      name = i18n.global.t("priorityMedium");
      color = "badge-soft-warning";
      oc = "badge bg-warning";
      break;
    case 0:
      name = i18n.global.t("priorityLow");
      color = "badge-soft-info";
      oc = "badge bg-info";
      break;
  }
  return { name, color, oc };
}

// tickets, тикети

// projects, проекти

function mutateStatusProject(e) {
  var name = "";
  var color = "";
  var oc = "";
  switch (e) {
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge badge-soft-info";
      oc = "badge bg-soft-info";
      break;
    case "jobs":
      name = i18n.global.t("statusInWork");
      color = "badge badge-soft-secondary";
      oc = "badge bg-soft-warning";
      break;
    case "completed":
      name = i18n.global.t("statusCompleted");
      color = "badge badge-soft-success";
      oc = "badge bg-soft-success";
      break;
    case "stasusDonetoConf":
      name = i18n.global.t("stasusDonetoConf");
      color = "badge badge-soft-success";
      oc = "badge bg-soft-success";
      break;
    case "changesMade":
      name = i18n.global.t("changesMade");
      color = "badge badge-soft-warning";
      oc = "badge bg-soft-warning";
      break;
    case "edits_added":
      name = i18n.global.t("edits_added");
      color = "badge badge-soft-secondary";
      oc = "badge bg-soft-warning";
      break;
    case "wait_verification":
      name = i18n.global.t("waiting_confirmation");
      color = "badge badge-soft-warning";
      oc = "-";
      break;
    case "confirmed":
      name = i18n.global.t("Confirmed");
      color = "badge badge-soft-success";
      oc = "-";
      break;
    case "waitingForVerification":
      name = i18n.global.t("waitVerification");
      color = "badge badge-soft-secondary";
      oc = "-";
      break;
    case "closed":
      name = i18n.global.t("statusCompleted");
      color = "badge badge-soft-success";
      oc = "-";
      break;
    case "decided":
      name = i18n.global.t("Решено");
      color = "badge badge-soft-success";
      oc = "-";
      break;
  }
  return { name, color, oc };
}

function getDateDeadline(e) {
  var date = "";
  storeS.dealines.forEach((el) => {
    if (el.deadlineId === e) {
      date = el.deadlineDate;
    }
  });
  return date;
}

function mutateUpdate(e) {
  var name = "";
  switch (e) {
    case "QMenu":
      name = i18n.global.t("App") + " " + i18n.global.t("QMenu");
      break;
    case "tPay":
      name = i18n.global.t("App") + " tPay";
      break;
    case "Screen_for_the_kitchen":
      name = i18n.global.t("Screen_for_the_kitchen");
      break;
    case "hallScreen":
      name = i18n.global.t("hallScreen");
      break;
    case "all":
      name = i18n.global.t("all");
      break;
    case "posterminal":
      name = "Pos-Terminal";
      break;
    case "dashboard":
      name = "Dashboard";
      break;
    case "skymarket":
      name = "Sky Market";
      break;
    case "sellup":
      name = "SellUP";
      break;
    case "hallscreen":
      name = i18n.global.t("orderBoard");
      break;
    case "inside":
      name = "Inside";
      break;
    case "android":
      name = i18n.global.t("onlyForAndroid");
      break;
    case "ios":
      name = i18n.global.t("onlyForIOS");
      break;
    default:
      break;
  }
  return name;
}

// projects, проекти

// fines, штрафи

function mutatetypeFine(e) {
  var name = "";
  switch (e) {
    case "beinglate":
      name = i18n.global.t("beinglate");
      break;
    case "taskNotCompletedTime":
      name = i18n.global.t("taskNotCompletedTime");
      break;
    case "projectNotCompletedTime":
      name = i18n.global.t("projectNotCompletedTime");
      break;
    case "rudeBehavior":
      name = i18n.global.t("rudeBehavior");
      break;
  }
  return name;
}

function mutateStatusFine(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "waitingСonfirmation":
      name = i18n.global.t("AwaitingСonfirmation");
      color = "badge badge-soft-warning";
      break;
    case "confirmed":
      name = i18n.global.t("Confirmed");
      color = "badge badge-soft-success";
      break;
    case "annul":
      name = i18n.global.t("annul");
      color = "badge badge-soft-danger";
      break;
  }
  return { name, color };
}

// fines, штрафи

// group, групи швидких відповідей

function getNameGroup(item) {
  var name = "";
  storeS.groups.forEach((el) => {
    if (el.groupId === item) {
      name = el.groupName;
    }
  });
  return name;
}

// group, групи швидких відповідей

// present, презентації

function mutateStatusPresent(e, obj) {
  var name = "";
  var color = "";
  switch (e) {
    case "inProgressNow":
      name = i18n.global.t("inProgressNow");
      color = "badge badge-soft-danger";
      break;
    case "delayed":
      name = obj.delayedDatetime
        ? i18n.global.t("PostponedUntil") + " " + obj.delayedDatetime
        : i18n.global.t("PostponedUntil");
      color = "badge badge-soft-warning";
      break;
    case "new":
      name = i18n.global.t("statusNew");
      color = "badge-soft-info";
      break;
    // case "rescheduled":
    //     name = i18n.global.t('statusrescheduled')
    //     color = 'badge-soft-secondary'
    // break;
    case "waiting_confirmation":
      name = i18n.global.t("waiting_confirmation");
      color = "badge-soft-danger";
      break;
    case "waiting_completed":
      name = i18n.global.t("waiting_completed");
      color = "badge-soft-info";
      break;
    case "Executed":
      name = i18n.global.t("Executed");
      color = "badge-soft-info";
      break;
    case "performedT":
      name = i18n.global.t("performedT");
      color = "badge-soft-success";
      break;
    case "statuswait_delete":
      name = i18n.global.t("statuswait_delete");
      color = "badge-soft-danger";
      break;
    case "canceled":
      name = i18n.global.t("canceled");
      color = "badge-soft-danger";
      break;
  }
  return { name, color };
}

// present, презентації

// notes, нотатки

function mutateColorNote(e) {
  var color = "";
  var icon = "";
  switch (e) {
    case "Personal":
      color = "info";
      icon = "ri-git-repository-private-line";
      break;
    case "Work":
      color = "warning";
      icon = "bx bx-home-smile";
      break;

    default:
      break;
  }
  return { color, icon };
}

// notes, нотатки

// docs , api

function mutateReqDocs(e) {
  var name = "";
  switch (e) {
    case 0:
      name = i18n.global.t("NotRequired");
      break;
    case 1:
      name = i18n.global.t("Required");
      break;
  }
  return name;
}

// docs , api

function mutateTypePay(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "invoice":
      name = i18n.global.t("invoic");
      color = "badge badge-soft-secondary";
      break;
    case "visa":
      name = "Visa";
      color = "badge badge-soft-info";
      break;
    case "liqpay":
      name = "LiqPay";
      color = "badge badge-soft-success";
      break;
  }
  return { name, color };
}

function mutateStatusDelivery(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "delivered":
      name = i18n.global.t("delivered");
      color = "badge bg-success";
      break;
    case "canceled":
      name = i18n.global.t("canceled");
      color = "badge bg-danger";
      break;
    case "new":
      name = i18n.global.t("new");
      color = "badge bg-info";
      break;
    case "inprogress":
      name = i18n.global.t("OntheRoad");
      color = "badge bg-secondary";
      break;
    case "returns":
      name = i18n.global.t("returns");
      color = "badge bg-secondary";
      break;
  }
  return { name, color };
}

// база знань

function getNameKWCategory(item) {
  var name = "";
  storeS.KBCategories.forEach((el) => {
    if (el.categoryId === item) {
      name = el.categoryName;
    }
  });
  return name;
}

// база знань

//logs, логи

function mutateActionLog(e) {
  var name = "";
  switch (e) {
    case "viewLessons":
      name = i18n.global.t("viewLessons");
      break;
    case "viewFaqPosts":
      name = i18n.global.t("viewFaqPosts");
      break;
    case "viewFaqCategories":
      name = i18n.global.t("viewFaqCategories");
      break;
    case "viewNotesList":
      name = i18n.global.t("viewNotesList");
      break;
    case "viewWorkerInfo":
      name = i18n.global.t("viewWorkerInfo");
      break;
    case "viewRequestsList":
      name = i18n.global.t("viewRequestsList");
      break;
    case "viewLogsList":
      name = i18n.global.t("viewLogsList");
      break;
    case "createBreak":
      name = i18n.global.t("createBreak");
      break;
    case "editEvent":
      name = i18n.global.t("editEvent");
      break;
    case "viewHolidayInfo":
      name = i18n.global.t("viewHolidayInfo");
      break;
    case "viewBreaksList":
      name = i18n.global.t("viewBreaksList");
      break;
    case "getProject":
      name = i18n.global.t("getProject");
      break;
    case "viewProjectsList":
      name = i18n.global.t("viewProjectsList");
      break;
    case "openShift":
      name = i18n.global.t("LogOpenShift");
      break;
    case "closeShift":
      name = i18n.global.t("LogCloseShift");
      break;
    case "earlyCloseShift":
      name = i18n.global.t("earlyCloseShift");
      break;
    case "viewProductsList":
      name = i18n.global.t("viewProductsList");
      break;
    case "lateForShift":
      name = i18n.global.t("lateForShift");
      break;
    case "getProduct":
      name = i18n.global.t("getProduct");
      break;
    case "viewComments":
      name = i18n.global.t("viewComments");
      break;
    case "getAccount":
      name = i18n.global.t("LogGetAccount");
      break;
    case "viewCompanyInfo":
      name = i18n.global.t("viewCompanyInfo");
      break;
    case "closeBreak":
      name = i18n.global.t("logCloseBreak");
      break;
    case "getRequest":
      name = i18n.global.t("getRequest");
      break;
    case "deleteRequestByCall":
      name = i18n.global.t("deleteRequestByCall");
      break;
    case "viewPresentationList":
      name = i18n.global.t("deleteRequestByCall");
      break;
    case "viewTasksList":
      name = i18n.global.t("viewTasksList");
      break;
    case "viewTicketsList":
      name = i18n.global.t("viewTicketsList");
      break;
    case "getArchiveRequests":
      name = i18n.global.t("getArchiveRequests");
      break;
    case "getArchiveDumps":
      name = i18n.global.t("getArchiveDumps");
      break;
    case "getArchivePresentations":
      name = i18n.global.t("getArchivePresentations");
      break;
    case "getArchiveTasks":
      name = i18n.global.t("getArchiveTasks");
      break;
    case "getArchiveTickets":
      name = i18n.global.t("getArchiveTickets");
      break;
    case "getArchiveProjects":
      name = i18n.global.t("getArchiveProjects");
      break;
    case "getArchiveShifts":
      name = i18n.global.t("getArchiveShifts");
      break;
    case "getArchiveSms":
      name = i18n.global.t("getArchiveSms");
      break;
    case "viewProductCaterories":
      name = i18n.global.t("viewProductCaterories");
      break;
    case "viewProvidersList":
      name = i18n.global.t("viewProvidersList");
      break;
    case "viewSaleDocuments":
      name = i18n.global.t("viewSaleDocuments");
      break;
    case "viewShortcutsList":
      name = i18n.global.t("viewShortcutsList");
      break;
    case "viewDeadlines":
      name = i18n.global.t("viewDeadlines");
      break;
    case "viewDeadlineInfo":
      name = i18n.global.t("viewDeadlineInfo");
      break;
    case "viewStatsByCallCenter":
      name = i18n.global.t("viewStatsByCallCenter");
      break;
    case "viewStatsByDevs":
      name = i18n.global.t("viewStatsByDevs");
      break;
    case "viewStatsByWorkers":
      name = i18n.global.t("viewStatsByWorkers");
      break;
    case "viewShiftsList":
      name = i18n.global.t("viewShiftsList");
      break;
    case "viewDaysOffList":
      name = i18n.global.t("viewDaysOffList");
      break;
    case "viewFinesList":
      name = i18n.global.t("viewFinesList");
      break;
    case "viewServices":
      name = i18n.global.t("viewServices");
      break;
    case "addEvent":
      name = i18n.global.t("logAddEvent");
      break;
    case "viewWorkerSettings":
      name = i18n.global.t("viewWorkerSettings");
      break;
    case "viewWorkerPerms":
      name = i18n.global.t("viewWorkerPerms");
      break;
    case "viewWorkerIpSettings":
      name = i18n.global.t("viewWorkerIpSettings");
      break;
    case "viewHolidaysList":
      name = i18n.global.t("viewHolidaysList");
      break;
    case "viewLatenessesList":
      name = i18n.global.t("viewLatenessesList");
      break;
    case "editWorker":
      name = i18n.global.t("editWorker");
      break;
    case "saveWorkerShiftSettings":
      name = i18n.global.t("saveWorkerShiftSettings");
      break;
    case "saveWorkerSettings":
      name = i18n.global.t("saveWorkerSettings");
      break;
    case "saveWorkerPerms":
      name = i18n.global.t("saveWorkerPerms");
      break;
    case "deleteRequestByCall":
      name = i18n.global.t("deleteRequestByCall");
      break;
    case "viewTicketInfo":
      name = i18n.global.t("viewTicketInfo");
      break;
    case "viewTasksInfo":
      name = i18n.global.t("viewTasksInfo");
      break;
    case "viewDumpsList":
      name = i18n.global.t("viewDumpsList");
      break;
    case "decidedTicket":
      name = i18n.global.t("viewDumpsList");
      break;
    case "inJobTicket":
      name = i18n.global.t("inJobTicket");
      break;
    case "viewCategoriesByCalls":
      name = i18n.global.t("inJobTicket");
      break;
    case "viewRequestsByCallsList":
      name = i18n.global.t("inJobTicket");
      break;
    case "viewColdCallsList":
      name = i18n.global.t("viewColdCallsList");
      break;
    case "viewColdCallFoldersList":
      name = i18n.global.t("viewColdCallFoldersList");
      break;
    case "reopenedTicket":
      name = i18n.global.t("reopenedTicketLog");
      break;
    case "viewShiftInfo":
      name = i18n.global.t("viewShiftInfo");
      break;
    case "viewTaskInfo":
      name = i18n.global.t("viewTaskInfoLog");
      break;
    case "addTaskNoConfirm":
      name = i18n.global.t("addTaskNoConfirmLog");
      break;
    case "getArchiveRequest":
      name = i18n.global.t("getArchiveRequestLog");
      break;
    case "createdTicket":
      name = i18n.global.t("createdTicketLog");
      break;
    case "getArchiveTicket":
      name = i18n.global.t("getArchiveTicketLog");
      break;
    case "closeRequest":
      name = i18n.global.t("closeRequestLog");
      break;
    case "viewCommentsWithoutCompany":
      name = i18n.global.t("viewCommentsWithoutCompanyLog");
      break;
    case "viewClientHistory":
      name = i18n.global.t("viewClientHistoryLog");
      break;
    case "sendSms":
      name = i18n.global.t("sendSmsLog");
      break;
    case "sendSmsOnSkyAPI":
      name = i18n.global.t("sendSmsOnSkyAPILog");
      break;
    case "tryUseInsideFromAnotherIp":
      name = i18n.global.t("tryUseInsideFromAnotherIp");
      break;
    case "viewWorkersList":
      name = i18n.global.t("viewWorkersList");
      break;
    default:
      name = e;
  }
  return name;
}

function mutateFromIP(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "213.111.120.210":
      name = "Офіс 1";
      color = "badge bg-info";
      break;
    case "94.100.214.57":
      name = "Офіс 2";
      color = "badge bg-success";
      break;
    case "46.149.80.41":
      name = "Красоти";
      color = "badge bg-danger";
      break;
    case "176.37.213.178":
      name = "Семпай";
      color = "badge bg-danger";
      break;

    default:
      break;
  }
  return { name, color };
}

//logs, логи

// tags, теги, мітки

function nameTag(item) {
  var name = "";
  var color = "";
  storeS.tags.forEach((el) => {
    if (el.tagId === item) {
      name = el.hashtagName;
      // color = el.color;
    }
  });
  return { name, color };
}

function nameTagFaq(item) {
  var name = "";
  var color = "";
  storeS.tagsFaq.forEach((el) => {
    if (el.tagId === item) {
      name = el.tagName;
      color = el.color;
    }
  });
  return { name, color };
}

function nameTagLess(item) {
  var name = "";
  var color = "";
  storeS.tagsLessons.forEach((el) => {
    if (el.tagId === item) {
      name = el.tagName;
      color = el.color;
    }
  });
  return { name, color };
}

// tags, теги, мітки

// файловий менеджер

function mutateFileManager(e) {
  var color = "";
  var icon = "";
  switch (e) {
    case "audio/mpeg":
      icon = "ri-file-music-line";
      color = "danger";
      break;
    case "application/x-msdownload":
      icon = "ri-file-line";
      color = "info";
      break;
    case "image/jpeg":
      icon = "ri-image-fill";
      color = "danger";
      break;
    case "image/png":
      color = "danger";
      icon = "bx bxs-file-png";
      break;
    case "image/vnd.adobe.photoshop":
      color = "danger";
      icon = "bx bxs-file-png";
      break;
    case "file":
      icon = "ri-file-fill";
      color = "secondary";
      break;
    case "application/json":
      icon = "bx bxs-file-json";
      color = "info";
      break;
    case "application/txt":
      icon = "bx bxs-file-txt";
      color = "info";
      break;
    case "text/plain":
      icon = "bx bxs-file-txt";
      color = "info";
      break;
    case "application/doc":
      icon = "bx bxs-file-doc";
      color = "info";
      break;
    case "application/docxdocx":
      icon = "bx bxs-file-doc";
      color = "info";
      break;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      icon = "ri-file-excel-fill";
      color = "success";
      break;
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      icon = "ri-file-excel-fill";
      color = "success";
      break;
    case "application/zip":
      icon = "ri-file-zip-fill";
      color = "secondary";
      break;
    case "application/x-rar":
      icon = "ri-inbox-archive-line";
      color = "secondary";
      break;
    case "video/quicktime":
      icon = "ri-video-line";
      color = "secondary";
      break;
    case "video/mp4":
      icon = "ri-video-fill";
      color = "info";
      break;
    case "application/pdf":
      icon = "bx bxs-file-pdf";
      color = "danger";
      break;
    case "application/apk":
      icon = "ri-android-fill";
      color = "success";
      break;
    case "application/octet-stream":
      icon = "ri-terminal-line";
      color = "success";
      break;
    case "application/x-x509-ca-cert":
      icon = "bx bx-certification";
      color = "success";
      break;
    case "text/php":
      icon = "bx bxl-php";
      color = "success";
      break;
    case "text/javascript":
      icon = "bx bxs-file-js";
      color = "danger";
      break;
    case "text/html":
      icon = "bx bxs-file-html";
      color = "info";
      break;
    default:
      icon = "ri-folder-2-fill";
      color = "warning";
      break;
  }
  return { color, icon };
}

// файловий менеджер

function mutateCompServer(e) {
  console.log(e);
  var name = "";
  var color = "";
  switch (e.split(" ")[0]) {
    case "mysky":
      name = i18n.global.t("") + " (mysky)";
      color = "badge bg-black";
      break;
    case "online-2":
      name = i18n.global.t("OldAdmin") + " (online-2)";
      color = "badge bg-danger";
      break;
    case "online-3":
      name = i18n.global.t("OldAdmin") + " (online-3)";
      color = "badge bg-danger";
      break;
    case "online-4":
      // на потім, якщо буде
      name = i18n.global.t("OldAdmin") + " (online-4)";
      color = "badge bg-danger";
      break;
    case "s-0":
      name = "Admin panel";
      color = "badge bg-black";
      break;
    case "s-1":
      name = i18n.global.t("OldAdmin");
      color = "badge bg-danger";
      break;
    case "s-2":
      name = i18n.global.t("OldAdmin");
      color = "badge bg-danger";
      break;
    case "s-3":
      name = i18n.global.t("NewAdmin_panel") + ` s-3 (s19h)`;
      color = "badge bg-warning";
      break;
    case "s-4":
      name = i18n.global.t("NewAdmin_panel") + ` s-4 (4t8h)`;
      color = "badge bg-warning";
      break;
    case "s-5":
      name = i18n.global.t("NewAdmin_panel") + ` s-5 (3s9h)`;
      color = "badge bg-warning";
      break;
    case "s-6":
      name = i18n.global.t("NewAdmin_panel") + ` s-6 (4s9h)`;
      color = "badge bg-warning";
      break;
    case "s-7":
      name = i18n.global.t("NewAdmin_panel") + ` s-7 (si8h)`;
      color = "badge bg-warning";
      break;
    case "s-8":
      name = i18n.global.t("NewAdmin_panel") + ` s-8 (n08h)`;
      color = "badge bg-warning";
      break;
    case "s-9":
      name = i18n.global.t("NewAdmin_panel") + ` s-9 (sz8h)`;
      color = "badge bg-warning";
      break;
    case "s-10":
      name = i18n.global.t("NewAdmin_panel") + ` s-10 (7s8h)`;
      color = "badge bg-warning";
      break;

    default:
      // Для невідомих серверів показуємо код якщо він є
      if (e && e.startsWith("s-")) {
        name = i18n.global.t("NewAdmin_panel") + ` ${e}`;
      } else if (e) {
        name = i18n.global.t("NewAdmin_panel") + ` ${e}`;
      } else {
        name = i18n.global.t("NewAdmin_panel");
      }
      color = "badge bg-warning";
      break;
  }
  return { name, color };
}

function mutateStatusDevices(e) {
  var status = "";
  var color = "";
  switch (e) {
    case true:
      status = i18n.global.t("Activated");
      color = "badge bg-success";
      break;
    case false:
      status = i18n.global.t("Deactivated");
      color = "badge bg-danger";
      break;
    default:
      status = "";
      break;
  }
  return { status, color };
}

function mutateTaxTypeCode(e) {
  var name = "";
  switch (e) {
    case "-1":
      name = i18n.global.t("WithoutVAT");
      break;
    case "0":
      name = i18n.global.t("VAT");
      break;
    case "1":
      name = i18n.global.t("Excise");
      break;
    case "2":
      name = i18n.global.t("PF");
      break;
    default:
      name = i18n.global.t("NotSpecified");
      break;
  }
  return name;
}

function mutatePayAction(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "pay":
      name = i18n.global.t("Replenishment");
      color = "badge bg-success fs-12";
      break;
    case "writeoff":
      name = i18n.global.t("WriteOff");
      color = "badge bg-danger fs-12";
      break;

    default:
      name = "-";
      color = "badge bg-black fs-12";
      break;
  }

  return { name, color };
}

function mutatePermsDash(e) {
  var name = "";

  switch (e) {
    case "1":
      name = i18n.global.t("Products");
      break;
    case "2":
      name = i18n.global.t("statistics");
      break;
    case "3":
      name = i18n.global.t("Finance");
      break;
    case "4":
      name = i18n.global.t("Marketing");
      break;
    case "5":
      name = i18n.global.t("Settings");
      break;
    case "6":
      name = i18n.global.t("device_pos_terminal");
      break;
    case "7":
      name = i18n.global.t("apps");
      break;
    case "100":
      name = i18n.global.t("AllProducts");
      break;
    case "101":
      name = i18n.global.t("warehousesGoods");
      break;
    case "102":
      name = i18n.global.t("ingredients");
      break;
    case "103":
      name = i18n.global.t("cookCards");
      break;
    case "104":
      name = i18n.global.t("semiFinishedProducts");
      break;
    case "105":
      name = i18n.global.t("Services");
      break;
    case "106":
      name = i18n.global.t("onSale");
      break;
    case "107":
      name = i18n.global.t("WarehouseBalances");
      break;
    case "108":
      name = i18n.global.t("ShowItemСost");
      break;
    case "109":
      name = i18n.global.t("ShowProductQuantity");
      break;
    case "110":
      name = i18n.global.t("switchOnePrice");
      break;
    case "201":
      name = i18n.global.t("main");
      break;
    case "202":
      name = i18n.global.t("MovementofGoods");
      break;
    case "203":
      name = i18n.global.t("topClient");
      break;
    case "204":
      name = i18n.global.t("byDays");
      break;
    case "205":
      name = i18n.global.t("productSpend");
      break;
    case "206":
      name = i18n.global.t("topSales");
      break;
    case "207":
      name = i18n.global.t("topClient");
      break;
    case "208":
      name = i18n.global.t("byDays");
      break;
    case "209":
      name = i18n.global.t("Отчет о списаных товарах");
      break;
    case "210":
      name = i18n.global.t("salesDynamic");
      break;
    case "211":
      name = i18n.global.t("RevenueReport");
      break;
    case "212":
      name = i18n.global.t("shopReport");
      break;
    case "213":
      name = i18n.global.t("Inventory");
      break;
    case "214":
      name = i18n.global.t("dangerOperation");
      break;
    case "215":
      name = i18n.global.t("recomendedForBuy");
      break;
    case "216":
      name = i18n.global.t("statByTaxes");
      break;
    case "217":
      name = i18n.global.t("reportByMarketing");
      break;
    case "218":
      name = "ABC";
      break;
    case "219":
      name = i18n.global.t("topIncoming");
      break;
    case "220":
      name = i18n.global.t("loyaltyProgram");
      break;
    case "221":
      name = i18n.global.t("admin_reportsGoodscategory");
      break;
    case "222":
      name = i18n.global.t("admin_reportsRevenuereport");
      break;
    case "223":
      name = i18n.global.t("admin_reportsSalesdynamic");
      break;
    case "224":
      name = i18n.global.t("admin_reportsEmployee");
      break;
    case "225":
      name = i18n.global.t("admin_reportsInventory");
      break;
    case "226":
      name = i18n.global.t("admin_reportsGoods");
      break;
    case "700":
      name = i18n.global.t("ShowItemСost");
      break;
    case "1000":
      name = i18n.global.t("capital");
      break;
    case "1001":
      name = i18n.global.t("admin_reportsWalletsstatus");
      break;
    case "1002":
      name = i18n.global.t("magazine");
      break;
    case "1003":
      name = i18n.global.t("reports2");
      break;
    case "1004":
      name = i18n.global.t("Calendar");
      break;
    case "1005":
      name = i18n.global.t("admin_reportsFin");
      break;
    case "1100":
      name = i18n.global.t("admin_marketingClients");
      break;
    case "1101":
      name = i18n.global.t("admin_marketingOffers");
      break;
    case "1102":
      name = i18n.global.t("admin_marketingStock");
      break;
    case "1103":
      name = i18n.global.t("admin_marketingDiscount");
      break;
    case "1104":
      name = i18n.global.t("admin_marketingBonus");
      break;
    case "1200":
      name = i18n.global.t("admin_settingsglobal");
      break;
    case "1201":
      name = i18n.global.t("admin_settingstradepoints");
      break;
    case "1202":
      name = i18n.global.t("admin_settingscategory");
      break;
    case "1203":
      name = i18n.global.t("categIncome");
      break;
    case "1204":
      name = i18n.global.t("admin_settingsexpenses");
      break;
    case "1205":
      name = i18n.global.t("admin_settingstax");
      break;
    case "1206":
      name = i18n.global.t("warehouses");
      break;
    case "1207":
      name = i18n.global.t("Terminals");
      break;
    case "1208":
      name = i18n.global.t("admin_settingsworkshop");
      break;
    case "1209":
      name = i18n.global.t("admin_settingshalls");
      break;
    case "1210":
      name = i18n.global.t("admin_settingstables");
      break;
    case "1211":
      name = i18n.global.t("device");
      break;
    case "1212":
      name = i18n.global.t("users");
      break;
    case "1213":
      name = i18n.global.t("invoices");
      break;
    case "1214":
      name = i18n.global.t("navProjects");
      break;
    case "1215":
      name = i18n.global.t("admin_settingsprovider");
      break;
    case "1216":
      name = i18n.global.t("tags");
      break;
    case "1217":
      name = i18n.global.t("admin_settingsnotices");
      break;
    case "1218":
      name = i18n.global.t("accessToFillials");
      break;
    case "1219":
      name = i18n.global.t("positionsOfWorkers");
      break;
    case "1220":
      name = i18n.global.t("predictions");
      break;
    case "1221":
      name = i18n.global.t("currencies");
      break;
    case "1222":
      name = i18n.global.t("admin_settingsmybalance");
      break;
    case "1400":
      name = i18n.global.t("pos_inventory");
      break;
    case "1401":
      name = i18n.global.t("Incomings");
      break;
    case "1402":
      name = i18n.global.t("pos_writeOff");
      break;
    case "1403":
      name = i18n.global.t("pos_transfer");
      break;
    case "1404":
      name = i18n.global.t("cashOperations");
      break;
    case "1405":
      name = i18n.global.t("reportForDuty");
      break;
    case "1406":
      name = i18n.global.t("historyOfSale");
      break;
    case "1407":
      name = i18n.global.t("returns");
      break;
    case "1408":
      name = i18n.global.t("prinPreBill");
      break;
    case "1409":
      name = i18n.global.t("cancelOrder");
      break;
    case "1410":
      name = i18n.global.t("sortGoods");
      break;
    case "1411":
      name = i18n.global.t("splitBill");
      break;
    case "1412":
      name = i18n.global.t("closeBillWithoutPay");
      break;
    case "1413":
      name = i18n.global.t("CreateTransaction");
      break;
    case "1414":
      name = i18n.global.t("giveAccessToAdmin");
      break;
    case "1415":
      name = i18n.global.t("pos_produce");
      break;
    case "1416":
      name = i18n.global.t("pos_devices");
      break;
    case "1417":
      name = i18n.global.t("pos_openMoneyBox");
      break;
    case "1418":
      name = i18n.global.t("pos_deleteUnSynchronizedChecks");
      break;
    case "1419":
      name = i18n.global.t("pos_correctCheck");
      break;
    case "1420":
      name = i18n.global.t("pos_changeWayToPay");
      break;
    case "2000":
      name = i18n.global.t("Sales");
      break;
    case "2001":
      name = i18n.global.t("Coming");
      break;
    case "2002":
      name = i18n.global.t("returns");
      break;
    case "2003":
      name = i18n.global.t("WriteOff");
      break;
    case "2004":
      name = i18n.global.t("transfer2");
      break;
    case "2005":
      name = i18n.global.t("Production");
      break;
    case "2006":
      name = i18n.global.t("returnGoodToProvider");
      break;
    case "3000":
      name = i18n.global.t("sales_cancelBill");
      break;
    case "3001":
      name = i18n.global.t("sales_showCostPrice");
      break;
    case "3100":
      name = i18n.global.t("ParishCreation");
      break;
    case "3101":
      name = i18n.global.t("ParishEditing");
      break;
    case "3102":
      name = i18n.global.t("ParishCancel");
      break;
    case "3103":
      name = i18n.global.t("create_return");
      break;
    case "3104":
      name = i18n.global.t("edit_return");
      break;
    case "3105":
      name = i18n.global.t("remove_return");
      break;
    case "3200":
      name = i18n.global.t("cancel_order");
      break;
    case "3201":
      name = i18n.global.t("return_showCostPrice");
      break;
    case "3300":
      name = i18n.global.t("CreateWriteoff");
      break;
    case "3301":
      name = i18n.global.t("EditWriteoff");
      break;
    case "3302":
      name = i18n.global.t("CancelWriteoff");
      break;
    case "3303":
      name = i18n.global.t("writeOff_showCostPrice");
      break;
    case "3400":
      name = i18n.global.t("CreateMoving");
      break;
    case "3401":
      name = i18n.global.t("EditMoving");
      break;
    case "3402":
      name = i18n.global.t("CancelMoving");
      break;
    case "3403":
      name = i18n.global.t("moving_showCostPrice");
      break;
    case "3500":
      name = i18n.global.t("CreateProduction");
      break;
    case "3501":
      name = i18n.global.t("EditProduction");
      break;
    case "3502":
      name = i18n.global.t("CancelProduction");
      break;
    case "3503":
      name = i18n.global.t("production_showCostPrice");
      break;
    case "3601":
      name = i18n.global.t("CreateInventory");
      break;
    case "3602":
      name = i18n.global.t("EditInventory");
      break;
    case "3603":
      name = i18n.global.t("inventory_showCostPrice");
      break;
    case "3700":
      name = i18n.global.t("allTransactions");
      break;
    case "3701":
      name = i18n.global.t("incomings");
      break;
    case "3702":
      name = i18n.global.t("spendings");
      break;
    case "3703":
      name = i18n.global.t("movements");
      break;
    case "3704":
      name = i18n.global.t("corrective");
      break;
    case "3705":
      name = i18n.global.t("Edited");
      break;
    case "3800":
      name = i18n.global.t("addTransaction");
      break;
    case "3801":
      name = i18n.global.t("editTransaction");
      break;
    case "3802":
      name = i18n.global.t("deleteTransaction");
      break;
    case "3803":
      name = i18n.global.t("recoveryTransaction");
      break;
    case "3900":
      name = i18n.global.t("addSpendTranscation");
      break;
    case "3901":
      name = i18n.global.t("editSpendTranscation");
      break;
    case "3902":
      name = i18n.global.t("delSpendTranscation");
      break;
    case "3903":
      name = i18n.global.t("recSpendTranscation");
      break;
    case "4000":
      name = i18n.global.t("addTransferTransaction");
      break;
    case "4001":
      name = i18n.global.t("editTransferTransaction");
      break;
    case "4002":
      name = i18n.global.t("delTransferTransaction");
      break;
    case "4003":
      name = i18n.global.t("recTransferTransaction");
      break;
    case "4100":
      name = i18n.global.t("addCorrectTransaction");
      break;
    case "4101":
      name = i18n.global.t("delCorrectTransaction");
      break;
    case "4200":
      name = i18n.global.t("reports_contrAgents");
      break;
    case "4201":
      name = "P&L";
      break;
    case "4202":
      name = "Cashflow";
      break;
    case "4203":
      name = "CashFlow Month";
      break;
    case "4204":
      name = i18n.global.t("depet");
      break;
    case "4205":
      name = i18n.global.t("balance");
      break;
    case "4206":
      name = i18n.global.t("reports_projects");
      break;
    case "4207":
      name = i18n.global.t("credit");
      break;
    case "4300":
      name = i18n.global.t("addClient");
      break;
    case "4301":
      name = i18n.global.t("removeClient");
      break;
    case "4302":
      name = i18n.global.t("saveClient");
      break;
    case "4400":
      name = i18n.global.t("addPropose");
      break;
    case "4401":
      name = i18n.global.t("delPropose");
      break;
    case "4402":
      name = i18n.global.t("editPropose");
      break;
    case "4500":
      name = i18n.global.t("addStockAk");
      break;
    case "4501":
      name = i18n.global.t("removeStockAk");
      break;
    case "4502":
      name = i18n.global.t("editStockAk");
      break;
    case "4600":
      name = i18n.global.t("addDiscount");
      break;
    case "4601":
      name = i18n.global.t("removeDiscount");
      break;
    case "4602":
      name = i18n.global.t("editDiscount");
      break;
    case "4700":
      name = i18n.global.t("addBonus");
      break;
    case "4701":
      name = i18n.global.t("removeBonus");
      break;
    case "4702":
      name = i18n.global.t("editBonus");
      break;
    case "4800":
      name = i18n.global.t("addTradePoint");
      break;
    case "4801":
      name = i18n.global.t("editTradePoint");
      break;
    case "4802":
      name = i18n.global.t("removeTradePoint");
      break;
    case "4803":
      name = i18n.global.t("giveAccess");
      break;
    case "4804":
      name = i18n.global.t("freezeTradePoint");
      break;
    case "4805":
      name = i18n.global.t("unFreezeTradePoint");
      break;
    case "4806":
      name = i18n.global.t("recoverTradePoint");
      break;
    case "4900":
      name = i18n.global.t("addProductsCateg");
      break;
    case "4901":
      name = i18n.global.t("editProductsCateg");
      break;
    case "4902":
      name = i18n.global.t("removeProductsCateg");
      break;
    case "5000":
      name = i18n.global.t("addCategIncome");
      break;
    case "5001":
      name = i18n.global.t("editCategIncome");
      break;
    case "5002":
      name = i18n.global.t("delCategIncome");
      break;
    case "5003":
      name = i18n.global.t("accessCategIncome");
      break;
    case "5100":
      name = i18n.global.t("addCatCost");
      break;
    case "5101":
      name = i18n.global.t("editCatCost");
      break;
    case "5102":
      name = i18n.global.t("delCatCost");
      break;
    case "5103":
      name = i18n.global.t("accessCatCost");
      break;
    case "5200":
      name = i18n.global.t("addTax");
      break;
    case "5201":
      name = i18n.global.t("editTax");
      break;
    case "5202":
      name = i18n.global.t("removeTax");
      break;
    case "5300":
      name = i18n.global.t("addWarehouse");
      break;
    case "5301":
      name = i18n.global.t("editWarehouse");
      break;
    case "5302":
      name = i18n.global.t("removeWarehouse");
      break;
    case "5303":
      name = i18n.global.t("accessWarehouses");
      break;
    case "5400":
      name = i18n.global.t("addTerminal");
      break;
    case "5401":
      name = i18n.global.t("editTerminal");
      break;
    case "5402":
      name = i18n.global.t("delTerminal");
      break;
    case "5403":
      name = i18n.global.t("accesTerminal");
      break;
    case "5500":
      name = i18n.global.t("addWorkshops");
      break;
    case "5501":
      name = i18n.global.t("editWorkshops");
      break;
    case "5502":
      name = i18n.global.t("removeWorkshops");
      break;
    case "5503":
      name = i18n.global.t("accesWorkshops");
      break;
    case "5600":
      name = i18n.global.t("addHall");
      break;
    case "5601":
      name = i18n.global.t("editHall");
      break;
    case "5602":
      name = i18n.global.t("delHall");
      break;
    case "5700":
      name = i18n.global.t("addTable");
      break;
    case "5701":
      name = i18n.global.t("editTable");
      break;
    case "5702":
      name = i18n.global.t("removeTable");
      break;
    case "5800":
      name = i18n.global.t("addDevice_perm");
      break;
    case "5801":
      name = i18n.global.t("editDevice");
      break;
    case "5802":
      name = i18n.global.t("delDevice");
      break;
    case "5900":
      name = i18n.global.t("addWorker");
      break;
    case "5901":
      name = i18n.global.t("editWorker");
      break;
    case "5902":
      name = i18n.global.t("delWorker");
      break;
    case "5903":
      name = i18n.global.t("workerAPI");
      break;
    case "5904":
      name = i18n.global.t("salaryWorker");
      break;
    case "6000":
      name = i18n.global.t("сreatingAccount");
      break;
    case "6001":
      name = i18n.global.t("editAccount");
      break;
    case "6002":
      name = i18n.global.t("delAccount");
      break;
    case "6003":
      name = i18n.global.t("accessAccount");
      break;
    case "6100":
      name = i18n.global.t("addProject");
      break;
    case "6101":
      name = i18n.global.t("editProject");
      break;
    case "6102":
      name = i18n.global.t("delProject");
      break;
    case "6103":
      name = i18n.global.t("recoveryProject");
      break;
    case "6104":
      name = i18n.global.t("accessProject");
      break;
    case "6200":
      name = i18n.global.t("addProvider");
      break;
    case "6201":
      name = i18n.global.t("editProvider");
      break;
    case "6202":
      name = i18n.global.t("delProvider");
      break;
    case "6300":
      name = i18n.global.t("terminal_showInv");
      break;
    case "6301":
      name = i18n.global.t("terminal_createInv");
      break;
    case "6302":
      name = i18n.global.t("terminal_editInv");
      break;
    case "6400":
      name = i18n.global.t("terminal_addInc");
      break;
    case "6401":
      name = i18n.global.t("terminal_editInc");
      break;
    case "6402":
      name = i18n.global.t("terminal_cancelInc");
      break;
    case "6500":
      name = i18n.global.t("terminal_addWriteOff");
      break;
    case "6501":
      name = i18n.global.t("terminal_editWriteOff");
      break;
    case "6502":
      name = i18n.global.t("terminal_cancelWriteOff");
      break;
    case "6600":
      name = i18n.global.t("terminal_addTransfer");
      break;
    case "6601":
      name = i18n.global.t("terminal_editTransfer");
      break;
    case "6602":
      name = i18n.global.t("terminal_cancelTransfer");
      break;
    case "6700":
      name = i18n.global.t("terminal_collection");
      break;
    case "6701":
      name = i18n.global.t("terminal_making");
      break;
    case "6702":
      name = i18n.global.t("terminal_expense");
      break;
    case "6800":
      name = i18n.global.t("terminal_addTransacIncom");
      break;
    case "6801":
      name = i18n.global.t("terminal_addTransacSpent");
      break;
    case "6802":
      name = i18n.global.t("terminal_addTransacTransfer");
      break;
    case "6803":
      name = i18n.global.t("terminal_addTransacCorrect");
      break;
    case "6900":
      name = i18n.global.t("addWaregouseGood");
      break;
    case "6901":
      name = i18n.global.t("editWaregouseGood");
      break;
    case "6902":
      name = i18n.global.t("delWaregouseGood");
      break;
    case "6903":
      name = i18n.global.t("delGoodsFromTrash");
      break;
    case "6904":
      name = i18n.global.t("recoveryGoodsFromTrash");
      break;
    case "7000":
      name = i18n.global.t("topSales_showSelfCost");
      break;
    case "7100":
      name = i18n.global.t("days_showSelfCost");
      break;
    case "7200":
      name = i18n.global.t("revenue_showSelfCost");
      break;
    case "7300":
      name = i18n.global.t("reportWorkShops_showSelfCost");
      break;
    case "7400":
      name = i18n.global.t("abc_goods");
      break;
    case "7401":
      name = i18n.global.t("abc_categsGood");
      break;
    case "7500":
      name = i18n.global.t("addTag");
      break;
    case "7501":
      name = i18n.global.t("renameTag");
      break;
    case "7502":
      name = i18n.global.t("delTag");
      break;
    case "7600":
      name = i18n.global.t("edit_editedTransaction");
      break;
    case "7601":
      name = i18n.global.t("del_editedTransaction");
      break;
    case "7602":
      name = i18n.global.t("recover_editedTransaction");
      break;
    case "7700":
      name = i18n.global.t("active_app");
      break;
    case "7701":
      name = i18n.global.t("access_app");
      break;
    case "7800":
      name = "skymarket";
      break;
    case "7801":
      name = "tpay";
      break;
    case "7802":
      name = "sendPulse";
      break;
    case "7803":
      name = "hallScreen";
      break;
    case "7804":
      name = "sellup";
      break;
    case "7805":
      name = "monobank";
      break;
    case "7806":
      name = "privat";
      break;
    case "7807":
      name = "shakeToPay";
      break;
    case "7808":
      name = "bookBeauty";
      break;
    case "7809":
      name = "bookingTable";
      break;
    case "7810":
      name = "sendcheck";
      break;
    case "7900":
      name = i18n.global.t("marketing_bonuses");
      break;
    case "8000":
      name = i18n.global.t("terminal_createProduce");
      break;
    case "8001":
      name = i18n.global.t("terminal_editProduce");
      break;
    case "8002":
      name = i18n.global.t("terminal_delProduce");
      break;
    case "8100":
      name = i18n.global.t("addIngredient");
      break;
    case "8101":
      name = i18n.global.t("editIngredient");
      break;
    case "8102":
      name = i18n.global.t("delIngredient");
      break;
    case "8200":
      name = i18n.global.t("addCookingCar");
      break;
    case "8201":
      name = i18n.global.t("editCookingCard");
      break;
    case "8202":
      name = i18n.global.t("delCookingCard");
      break;
    case "8300":
      name = i18n.global.t("addSemiProduct");
      break;
    case "8301":
      name = i18n.global.t("editSemiProduct");
      break;
    case "8302":
      name = i18n.global.t("delSemiProduct");
      break;
    case "8400":
      name = i18n.global.t("addServices");
      break;
    case "8401":
      name = i18n.global.t("editServices");
      break;
    case "8402":
      name = i18n.global.t("delServices");
      break;
    case "8500":
      name = i18n.global.t("addPosition");
      break;
    case "8501":
      name = i18n.global.t("editPosition");
      break;
    case "8502":
      name = i18n.global.t("delPosition");
      break;
    case "8503":
      name = i18n.global.t("recoveryPosition");
      break;
    case "8600":
      name = i18n.global.t("addPredictions");
      break;
    case "8601":
      name = i18n.global.t("editPredictions");
      break;
    case "8602":
      name = i18n.global.t("delPredictions");
      break;
    case "8700":
      name = i18n.global.t("addCurrency");
      break;
    case "8701":
      name = i18n.global.t("editCurrency");
      break;
    case "8702":
      name = i18n.global.t("delCurrency");
      break;
    case "9000":
      name = i18n.global.t("terminal_addDevice");
      break;
    case "9001":
      name = i18n.global.t("terminal_editDevice");
      break;
    case "9002":
      name = i18n.global.t("terminal_delDevice");
      break;
    case "9003":
      name = i18n.global.t("terminal_activeDevice");
      break;
    case "9100":
      name = i18n.global.t("seeReplenishBalance");
      break;
    case "9101":
      name = i18n.global.t("seeWriteOffBalance");
      break;
    case "9102":
      name = i18n.global.t("myAccount");
      break;
    case "9200":
      name = i18n.global.t("terminal_seeListInk");
      break;
    case "9201":
      name = i18n.global.t("terminal_seeListIncoms");
      break;
    case "9202":
      name = i18n.global.t("terminal_seeListSpents");
      break;
    case "9300":
      name = i18n.global.t("abilityToSend");
      break;
    case "9301":
      name = i18n.global.t("abilityToCheckArchive");
      break;

    default:
      name = "Невідомий пермс";
      break;
  }

  return name;
}

function mutateItemApps(e) {
  var app = {
    name: "",
    img: "",
    desc: "",
    price: "",
    infoConnect: "",
    module: "",
  };

  switch (e.appName) {
    case "posterminal":
      app.name = "POS-" + i18n.global.t("terminal");
      app.img = "posterminal.png";
      app.desc = i18n.global.t("CashierWorkplace");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "posterminal";
      break;
    case "shakeToPay":
      app.name = "Expirenza by mono";
      app.img = "expirenza.png";
      app.desc = i18n.global.t("appExpDesc");
      app.price = "532.13" + "₴ " + i18n.global.t("payMonth");
      app.infoConnect = i18n.global.t("connectionGoestoCompany");
      app.module = "expirenza";
      break;
    case "monobank":
      app.name = "MonoBank";
      app.img = "monobank.png";
      app.desc = i18n.global.t("appMonoDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "monobank";
      break;
    case "privatbank":
      app.name = "ПриватБанк";
      app.img = "privatbank.png";
      app.desc = i18n.global.t("appMonoDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "privatbank";
      break;
    case "privat24":
      app.name = "ПриватБанк";
      app.img = "privatbank.png";
      app.desc = i18n.global.t("appMonoDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "privatbank";
      break;
    case "bookBeauty":
      app.name = "bookBeauty";
      app.img = "bookBeauty.png";
      app.desc = i18n.global.t("OnlineRegistration");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "bookBeauty";
      break;
    case "sendcheck":
      app.name = i18n.global.t("sendcheck");
      app.img = "sendcheck.jpeg";
      app.desc = i18n.global.t("SendingChecksSMS");
      app.price =
        i18n.global.t("CostofOneSMS") + " - 1.5 " + i18n.global.t("UAH");
      app.infoConnect = i18n.global.t("FundsareDebitedBalance");
      app.module = "sendcheck";
      break;
    case "tpay":
      app.name = i18n.global.t("QRMenuandPay");
      app.img = "qrmenupay.png";
      app.desc = i18n.global.t("QRMenuandPayDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "tpay";
      break;
    case "loyallyst":
      app.name = "Loyallyst";
      app.img = "loyallyst.png";
      app.desc = i18n.global.t("LoyallystDesc");
      app.price = "258.00₴/точка";
      app.infoConnect = i18n.global.t("PaidSeparately");
      app.module = "loyallyst";
      break;
    case "stopList":
      app.name = "stopList";
      app.img = "stopList.png";
      app.desc = i18n.global.t("stopListDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "stopList";
      break;
    case "glovo":
      app.name = "Glovo";
      app.img = "glovo.png";
      app.desc = i18n.global.t("GlovoDesc");
      app.price = "99.00₴/торгова точка";
      app.infoConnect = "🤘🏼";
      app.module = "glovo";
      break;
    case "skymarket":
      app.name = "Sky Market";
      app.img = "skymarket.jpeg";
      app.desc = i18n.global.t("OnlineStore");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "skymarket";
      break;
    case "qrPay":
      app.name = i18n.global.t("QRMenuandPay");
      app.img = "qrmenupay.png";
      app.desc = i18n.global.t("QRMenuandPayDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "tpay";
      break;
    case "kitchenScreen":
      app.name = "kitchen Screen";
      app.img = "kitchenScreen.png";
      app.desc = i18n.global.t("Screen_for_the_kitchen");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "kitchenScreen";
      break;
    case "hallScreen":
      app.name = "Hall Screen";
      app.img = "hallScreen.png";
      app.desc = i18n.global.t("hallscreen_windows");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "hallScreen";
      break;
    case "warehouseRequest":
      app.name = i18n.global.t("warehouseRequest");
      app.img = "warehouseRequest.png";
      app.desc = i18n.global.t("warehouseRequestDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "hallScreen";
      break;
    case "promocodes":
      app.name = i18n.global.t("PromocodesApp");
      app.img = "icon-site.webp";
      app.desc = i18n.global.t("PromocodesAppDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "promocodes";
      break;
    case "tableReservations":
      app.name = i18n.global.t("TableReservationsApp");
      app.img = "icon-site.webp";
      app.desc = i18n.global.t("TableReservationsAppDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "tableReservations";
      break;
    case "finance":
      app.name = i18n.global.t("FinanceModuleApp");
      app.img = "icon-site.webp";
      app.desc = i18n.global.t("FinanceModuleAppDesc");
      app.price = i18n.global.t("PaidSeparately");
      app.infoConnect = "🤘🏼";
      app.module = "finance";
      break;
    case "accounting":
      app.name = i18n.global.t("AccountingApp");
      app.img = "icon-site.webp";
      app.desc = i18n.global.t("AccountingAppDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "accounting";
      break;
    case "loyaltyua":
      app.name = "LoyaltyUA";
      app.img = "icon-site.webp";
      app.desc = i18n.global.t("LoyaltyUAAppDesc");
      app.price = i18n.global.t("IncludedInTariff");
      app.infoConnect = "🤘🏼";
      app.module = "loyaltyua";
      break;
    case "offlinePrro":
      app.name = i18n.global.t("OfflinePrroApp");
      app.img = "icon-site.webp";
      app.desc = i18n.global.t("OfflinePrroAppDesc");
      app.price = i18n.global.t("PaidSeparately");
      app.infoConnect = "🤘🏼";
      app.module = "offlinePrro";
      break;

    default:
      // показуємо сирий appName, щоб нові додатки не зливались у «Невідомий додаток»
      app.name = e.appName || i18n.global.t("UnknownApplication");
      app.img = "icon-site.webp";
      app.desc = "-";
      app.price = "-";
      app.infoConnect = "-";
      app.module = "-";
      break;
  }

  return app;
}

function mutateLogoProjects(e) {
  var name = "";
  var color = "";
  switch (e) {
    case "SkyService":
      name = i18n.global.t("Replenishment");
      color = "badge bg-success fs-12";
      break;
    case "Inside":
      name = i18n.global.t("WriteOff");
      color = "@/assets/logo_inside_sm.png";
      break;

    default:
      name = "-";
      color = "badge bg-black fs-12";
      break;
  }

  return { name, color };
}

function mutateAdequacy(e) {
  var name = "";
  var color = "";
  var oc = "";
  switch (e) {
    case "3":
      name = i18n.global.t("Файний клієнт");
      color = "badge-soft-success";
      oc = "badge bg-success";
      break;
    case "2":
      name = i18n.global.t("50/50");
      color = "badge-soft-warning";
      oc = "badge bg-warning";
      break;
    case "1":
      name = i18n.global.t("Поганий клієнт");
      color = "badge-soft-danger";
      oc = "badge bg-danger";
      break;
    default:
      name = "-";
      color = "badge-soft-primary";
      oc = "badge bg-primary";
      break;
  }
  return { name, color, oc };
}

function mutateHistoryTicketAction(e) {
  var name = "";
  switch (e) {
    case "changePriority":
      name = i18n.global.t("changePriority");
      break;
    case "changeProblemEnvironment":
      name = i18n.global.t("ChangingProblemEnvironment");
      break;
    default:
      name = "-";
      break;
  }
  return name;
}

function mutateSinceProblemKnown(e) {
  var name = "";
  switch (e) {
    case "day":
      name = i18n.global.t("day");
      break;
    case "several_days":
      name = i18n.global.t("Several_days");
      break;
    case "week":
      name = i18n.global.t("week");
      break;
    case "month":
      name = i18n.global.t("Month");
      break;
    case "quarter":
      name = i18n.global.t("Quarter");
      break;
    case "half_year":
      name = i18n.global.t("half_year");
      break;
    case "year":
      name = i18n.global.t("Year");
      break;
    default:
      name = "-";
      break;
  }
  return name;
}

function mutateStatusCandidate(e) {
  var name = "";
  var color_bagde = "";
  var color = "";

  switch (e) {
    case "new_request":
      // Нова заявка
      name = i18n.global.t("Нова заявка");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "will_interview":
      // Назначена співбесіда
      name = i18n.global.t("Назначена співбесіда");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "denied":
      // Відмовлено
      name = i18n.global.t("Відмовлено");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "under_question":
      // Під питанням
      name = i18n.global.t("Під питанням");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "intern":
      // Стажується
      name = i18n.global.t("Стажується");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "not_pass_internship":
      // Не пройшов стажування
      name = i18n.global.t("Не пройшов стажування");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "works":
      // Працює
      name = i18n.global.t("Працює");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "released":
      // Звільнено
      name = i18n.global.t("Звільнено");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    default:
      name = "-";
      color_bagde = "";
      color = "";
      break;
  }
  return { name, color_bagde, color };
}

function mutateTypeTimelineTicket(e) {
  var name = "";
  switch (e) {
    case "helpByTicket":
      name = i18n.global.t("helpByTicket");
      break;
    case "addTicketForTesting":
      name = i18n.global.t("addTicketForTesting");
      break;
    case "createTicket":
      name = i18n.global.t("CreatingTicket");
      break;
    case "changeProblemEnvironment":
      name = i18n.global.t("ChangingTheEnvironmentProblem");
      break;
    case "changePriority":
      name = i18n.global.t("ChangePriorityTimeline");
      break;
    case "inJobTicket":
      name = i18n.global.t("inJobTicketTimeLine");
      break;
    case "editEstimatedDate":
      name = i18n.global.t("editEstimatedDateTimeLine");
      break;
    case "saveAssignedWorkers":
      name = i18n.global.t("saveAssignedWorkersTimeLine");
      break;
    case "decideTicket":
      name = i18n.global.t("decideTicketTimeLine");
      break;
    case "exitAssignedTicket":
      name = i18n.global.t("exitAssignedTicketTimeLine");
      break;
    case "reopenTicket":
      name = i18n.global.t("reopenTicketTimeLine");
      break;
    case "closeTicket":
      name = i18n.global.t("closeTicketTimeLine");
      break;
    case "getTicket":
      name = i18n.global.t("getTicketTimeLine");
      break;
    case "inJobTicketManually":
      name = i18n.global.t("inJobTicketTimeLine");
      break;
    case "removeInJobWorker":
      name = i18n.global.t("removeInJobWorkerTimeLine");
      break;
    case "exitTicket":
      name = i18n.global.t("exitAssignedTicketTimeLine");
      break;
    case "resumeTicket":
      name = i18n.global.t("resumeTicketTimeLine");
      break;
    case "stopTicket":
      name = i18n.global.t("stopTicket");
      break;
    case "waitReleaseTicket":
      name = i18n.global.t("waitReleaseTicket");
      break;
    case "restoreTicket":
      name = i18n.global.t("Restored");
      break;
    case "deleteTicket":
      name = i18n.global.t("DeleteTicket");
      break;
    case "editTicket":
    case "saveTicketChanges":
      name = i18n.global.t("EditTicket");
      break;
    case "changeTicketType":
      name = i18n.global.t("ChangeTicketType");
      break;
    case "changeDecidedStatus":
      name = i18n.global.t("changeDecidedStatus");
      break;
    case "saveHashtags":
      name = i18n.global.t("saveHashtagsTimeLine");
      break;
    case "savePhonesByTicket":
      name = i18n.global.t("numbers");
      break;
    default:
      name = "-";
      break;
  }
  return name;
}

function mutateStatusChecklist(e) {
  var name = "";
  var color_bagde = "";
  var color = "";

  switch (e) {
    case "passed":
      // успішно
      name = i18n.global.t("Успішно");
      color_bagde = "badge-soft-success";
      color = "bg-success";
      break;
    case "failed":
      // не вдалось
      name = i18n.global.t("Не вдалося");
      color_bagde = "badge-soft-danger";
      color = "bg-danger";
      break;
    case "blocked":
      // Блокуючий
      name = i18n.global.t("Блокуючий");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    case "in_progress":
      // В роботі
      name = i18n.global.t("В роботі");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "not_run":
      // Не перевірено
      name = i18n.global.t("Не розпочато");
      color_bagde = "badge-soft-secondary";
      color = "bg-secondary";
      break;
    case "skipped":
      // Пропущено
      name = i18n.global.t("Пропущено");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    default:
      name = "-";
      color_bagde = "";
      color = "";
      break;
  }
  return { name, color_bagde, color };
}

function mutateSeriousnessDefect(e) {
  var name = "";
  var color_bagde = "";
  var color = "";

  switch (e) {
    case "blocker":
      // Блокуючий
      name = i18n.global.t("Блокуючий");
      color_bagde = "badge-soft-success";
      color = "bg-success";
      break;
    case "critical":
      // Критична помилка
      name = i18n.global.t("Критична помилка");
      color_bagde = "badge-soft-danger";
      color = "bg-danger";
      break;
    case "major":
      // Значна
      name = i18n.global.t("Значна");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    case "minor":
      // Незначна
      name = i18n.global.t("Незначна");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "trivial":
      // Тривіальний
      name = i18n.global.t("Тривіальний");
      color_bagde = "badge-soft-secondary";
      color = "bg-secondary";
      break;
    case "tweak":
      // Незручність
      name = i18n.global.t("Незручність");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    case "text":
      // Текстова помилка
      name = i18n.global.t("Текстова помилка");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    default:
      name = "-";
      color_bagde = "";
      color = "";
      break;
  }
  return { name, color_bagde, color };
}

function mutateStatusReport(e) {
  var name = "";
  var color_bagde = "";
  var color = "";

  switch (e) {
    case "new":
      // Новий
      name = i18n.global.t("Новий");
      color_bagde = "badge-soft-success";
      color = "bg-success";
      break;
    case "feedback":
      // Необхідна додаткова інформація
      name = i18n.global.t("Необхідна додаткова інформація");
      color_bagde = "badge-soft-danger";
      color = "bg-danger";
      break;
    case "acknowledged":
      // Доведено до відома
      name = i18n.global.t("Доведено до відома");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    case "accepted":
      // Дефект відтворено та підтверджено
      name = i18n.global.t("Дефект відтворено та підтверджено");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "assigned":
      // Баг-репорт призначений
      name = i18n.global.t("Баг-репорт призначений");
      color_bagde = "badge-soft-secondary";
      color = "bg-secondary";
      break;
    case "resolved":
      // Питання вирішене. Потрібне підтвердження від тестувальника, що дефект усунутий
      name = i18n.global.t(
        "Питання вирішене. Потрібне підтвердження від тестувальника, що дефект усунутий"
      );
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    case "closed":
      // Виправлення дефекту підтверджено
      name = i18n.global.t("Виправлення дефекту підтверджено");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    default:
      name = "-";
      color_bagde = "";
      color = "";
      break;
  }
  return { name, color_bagde, color };
}

function mutateEnvironmentReport(e) {
  var name = "";
  var color_bagde = "";
  var color = "";
  var icon = "";

  switch (e) {
    case "windows":
      // віндовс
      name = "Windows";
      color_bagde = "badge-soft-success";
      color = "info";
      icon = "ri-windows-fill";
      break;
    case "ios":
      // apple
      name = "iOS";
      color_bagde = "badge-soft-danger";
      color = "dark";
      icon = "ri-apple-fill";
      break;
    case "android":
      // android
      name = "Android";
      color_bagde = "badge-soft-dark";
      color = "success";
      icon = "ri-android-fill";
      break;
    case "chrome":
      // chrome
      name = "Google Chrome";
      color_bagde = "badge-soft-info";
      color = "warning";
      icon = "ri-chrome-fill";
      break;
    case "opera":
      // opera
      name = "Opera";
      color_bagde = "badge-soft-info";
      color = "danger";
      icon = "ri-opera-fill";
      break;
    case "edge":
      // edge
      name = "Edge";
      color_bagde = "badge-soft-info";
      color = "info";
      icon = "ri-edge-fill";
      break;
    case "firefox":
      // firefox
      name = "FireFox";
      color_bagde = "badge-soft-info";
      color = "warning";
      icon = "ri-firefox-fill";
      break;
    case "safari":
      // safari
      name = "Safari";
      color_bagde = "badge-soft-info";
      color = "info";
      icon = "ri-safari-fill";
      break;
    default:
      name = "-";
      color_bagde = "";
      color = "";
      icon = "";
      break;
  }
  return { name, color_bagde, color, icon };
}

function mutateEmoji(e) {
  var emoji = "";

  switch (e) {
    case "fire":
      emoji = "🔥";
      break;
    case "thumbs_up":
      emoji = "👍";
      break;
    case "smile":
      emoji = "😊";
      break;
    case "heart":
      emoji = "❤️";
      break;
    case "laugh":
      emoji = "🤣";
      break;
    case "cool":
      emoji = "😎";
      break;
    case "wink":
      emoji = "😉";
      break;
    case "mind_blown":
      emoji = "🤯";
      break;
    case "angry":
      emoji = "😡";
      break;
    case "thumbs_down":
      emoji = "👎";
      break;
    case "starstruck":
      emoji = "🤩";
      break;
    case "poop":
      emoji = "💩";
      break;
    case "ok":
      emoji = "👌";
      break;

    default:
      break;
  }

  return emoji;
}

function mutateKanbanColumn(e, color) {
  // мутейт колонок проекту
  var name = "";
  var color_bagde = "";
  var color = "";

  switch (e) {
    case "ToBePerformed":
      // Новий
      name = i18n.global.t("TobePerformed");
      color_bagde = "badge-soft-success";
      color = "bg-success";
      break;
    case "InWork":
      // Необхідна додаткова інформація
      name = i18n.global.t("statusInWork");
      color_bagde = "badge-soft-danger";
      color = "bg-danger";
      break;
    case "Testing":
      // Доведено до відома
      name = i18n.global.t("Testing");
      color_bagde = "badge-soft-dark";
      color = "bg-dark";
      break;
    case "InPreRelease":
      // Дефект відтворено та підтверджено
      name = i18n.global.t("pre_release");
      color_bagde = "badge-soft-info";
      color = "bg-info";
      break;
    case "Completed":
      // Баг-репорт призначений
      name = i18n.global.t("statusCompleted");
      color_bagde = "badge-soft-secondary";
      color = "bg-secondary";
      break;
    default:
      name = e;
      color_bagde = "";
      color = "";
      break;
  }
  return { name, color_bagde, color };
}

function mutateReviewsGroups(e) {
  // мутейт назв розділів відгуків
  var name = "";

  switch (e) {
    case "positions_list":
      // Посади співробітників
      name = i18n.global.t("Посади співробітників");
      break;
    case "payment_methods_list":
      // Методи оплат
      name = i18n.global.t("Методи оплат ");
      break;
    case "order_channels_list":
      // Канали замовлень
      name = i18n.global.t("Канали замовлень ");
      break;
    case "clients_groups_stats":
      // Статистика груп клієнтів
      name = i18n.global.t("Статистика груп клієнтів");
      break;
    case "workers_report":
      // Звіт по співробітникам
      name = i18n.global.t("Звіт по співробітникам");
      break;
    case "tradepoints_balances":
      // Залишки по ТТ
      name = i18n.global.t("Залишки по ТТ");
      break;
    case "clients_groups_list":
      // Групи клієнтів в маркетингу
      name = i18n.global.t("Групи клієнтів в маркетингу");
      break;
    case "salary_statistics":
      // Аналітика нарахування ЗП
      name = i18n.global.t("Аналітика нарахування ЗП");
      break;
    case "check_settings_page":
      // чек та передбачення
      name = i18n.global.t("Чек та передбачення");
      break;
    case "module_glovo":
      // Глово апка
      name = i18n.global.t("Модуль Glovo");
      break;
    default:
      name = e;
      break;
  }
  return { name };
}

function mutateAccessType(e) {
  // мутейт типу доступу
  var name = "";
  var color_bagde = "";
  var color = "";

  switch (e) {
    case "read":
      // Новий
      name = i18n.global.t("Читання");
      color_bagde = "badge badge-soft-info";
      color = "bg-info";
      break;
    case "full_access":
      // Необхідна додаткова інформація
      name = i18n.global.t("Повний доступ");
      color_bagde = "badge badge-soft-info";
      color = "bg-info";
      break;

    default:
      name = e;
      color_bagde = "";
      color = "";
      break;
  }
  return { name, color_bagde, color };
}

function mutateAccessStatusClient(e) {
  // статус запиту підключення
  var name = "";
  var color = "";
  switch (e) {
    case "approved":
      name = "Підтверджено";
      color = "badge bg-success";
      break;
    case "pending":
      name = "Очікується";
      color = "badge bg-warning";
      break;
    case "expired":
      name = "Токен прострочено";
      color = "badge bg-danger";
      break;
    case "denied":
      name = "Відхилено";
      color = "badge bg-danger";
      break;
  }
  return { name, color };
}

export {
  mutateStatusMessage,
  mutateStatusDumpArchive,
  mutatePriority,
  mutateTypeHoliday,
  mutateReasonHoliday,
  mutateStatusHoliday,
  mutateTicket,
  mutateWayproblem,
  mutateStatusUpdates,
  mutateStatusTicket,
  mutatePriorityTicket,
  mutateDecidedStatusTicket,
  mutateBreak,
  mutateTypeCalendar,
  mutateStatusCalendar,
  mutateImgFiles,
  mutateImgWorker,
  mutateWorkerJob,
  titleCategory,
  mutateTemplateTicketPrinter,
  mutateModePrinter,
  mutateDirectionPrint,
  mutateTypeDevices,
  mutateOS,
  mutateProtocol,
  mutateWhatToPrint,
  mutatePromise,
  mutateChineseMode,
  mutateTransferMode,
  getFlag,
  mutateStatusAccounts,
  mutatePriorityAccounts,
  mutateWorkersAccount,
  mutateWorkerAllAccountFormRight,
  mutateUserCompanies,
  mutateDomainSkyMarket,
  mutateTariffingOutlets,
  mutateConnectStatus,
  mutateTypeHistoryAcc,
  mutateStatusInv,
  mutateProviderInv,
  mutateServerSyncOutlets,
  mutatePayPayments,
  mutatePayPickupSkyMarket,
  mutateServices,
  mutateStatusServices,
  mutateDirWorker,
  mutateBusiness,
  mutateActivity,
  mutateTypeFound,
  mutateStatus,
  mutateTypeTicket,
  mutatePriorityOther,
  mutateStatusProject,
  getDateDeadline,
  mutatetypeFine,
  mutateStatusFine,
  mutateTypeTask,
  mutateStatusTask,
  getNameGroup,
  mutateStatusPresent,
  mutateColorNote,
  mutateProblemEnv,
  mutateReqDocs,
  mutateUpdate,
  mutateTypeRequest,
  mutateTypePay,
  mutateStatusDelivery,
  getNameKWCategory,
  mutateCommentsAcc,
  mutateStatusDel,
  mutateWorkerPosition,
  getNameCountry,
  mutateActionLog,
  mutateFromIP,
  nameTag,
  nameTagFaq,
  nameTagLess,
  mutateNoticeAlerts,
  mutateFileManager,
  mutateCompServer,
  mutateStatusDevices,
  mutateTaxTypeCode,
  getMonth,
  mutatePayAction,
  mutatePhone,
  mutateItemApps,
  mutateLogoProjects,
  mutateAppName,
  mutatePaymentType,
  mutateAdequacy,
  mutateTypeMessage,
  mutateViewMessage,
  mutateRecipientMessage,
  mutateTriggers,
  mutatePermsDash,
  mutateHistoryTicketAction,
  mutateMonitoringType,
  mutateSinceProblemKnown,
  mutateStatusCandidate,
  mutateTypeTimelineTicket,
  mutateStatusChecklist,
  mutateSeriousnessDefect,
  mutateStatusReport,
  mutateEnvironmentReport,
  mutateReleasesCalendar,
  mutateEmoji,
  mutateKanbanColumn,
  mutateReviewsGroups,
  mutateAccessType,
  mutateAccessStatusClient,
};
